import { DESKTOP_NATIVE_ENGLISH } from "./desktop-native"
import { UI_PREVIEW_ENGLISH } from "@/settings/appearance/ui-preview-en"

export const dict = {
  "web.update.title": "Update available",
  "web.update.description": "Reload to use the latest version. Finish any unsaved edits first.",
  "web.update.action": "Update and reload",
  "web.update.otherTabs":
    "Close other OMM tabs or app windows, then try again. They will keep their current version until you close them.",
  "web.update.failed": "Couldn’t save your work or apply the update. This page has been kept open. Try again.",
  "web.update.updating": "Updating OMM",
  "web.update.saving": "Saving your drafts before reloading…",
  "cloud.workspace.opening": "Opening workspace…",
  "cloud.workspace.preparing": "Getting your workspace ready.",
  "cloud.workspace.failedTitle": "Couldn’t open workspace",
  "cloud.workspace.failed": "You’re signed in, but your workspace isn’t ready.",
  "cloud.workspace.timeout": "Opening your workspace timed out. Try again.",
  "cloud.workspace.network": "We couldn’t reach your workspace. Check your connection and try again.",
  "cloud.workspace.cancelled.title": "Workspace connection cancelled",
  "cloud.workspace.cancelled.description": "Try again when you’re ready to connect.",
  "cloud.workspace.details": "Technical details",
  "cloud.workspace.signOut": "Sign out of this browser",
  "remote.accountChanged": "The remote account changed. Open the remote project picker again to continue.",
  "remote.unavailable": "Remote projects are unavailable for the current account.",
  "remote.ssh.title": "Expert: direct SSH",
  "remote.ssh.warning":
    "Normal OMM access is recommended. SSH includes unrestricted sudo in your VM. Changes can break OMM or the VM and are your responsibility.",
  "remote.ssh.state": "SSH status: {{state}}",
  "remote.ssh.fingerprint": "Initial key fingerprint: {{fingerprint}}",
  "remote.ssh.keyNote":
    "Downloads contain the original key, even after you change your VM's authorized keys. Save it privately; on Linux/macOS, run chmod 600 on the downloaded file before connecting. Use your saved file's path with -i.",
  "remote.ssh.download": "Download initial SSH key",
  "remote.ssh.copy": "Copy SSH command",
  "session.new.workspace.main": "Main worktree",
  "session.new.git.notRepository": "Not a Git repository",
  "remote.details.title": "Workspace details",
  "remote.details.state": "State",
  "remote.details.id": "Workspace ID",
  "remote.details.image": "Image",
  "remote.details.build": "Build",
  "remote.details.directory": "Workspace root",
  "remote.details.selected": "Selected resources",
  "remote.details.observed": "Observed allocation",
  "remote.details.limit": "Your allowance",
  "remote.details.reservedDisk": "Reserved disk (including configuration)",
  "remote.details.mib": "{{value}} MiB",
  "remote.details.minutes": "{{value}} min",
  "remote.details.size": "{{cpu}} vCPU / {{memory}} GiB RAM / {{disk}} GiB disk",
  "remote.details.idle": "Idle shutdown",
  "remote.details.background": "Background work limit",
  "remote.details.sessionExpiry": "Management session expires",
  "remote.details.leaseExpiry": "Connection lease expires",
  "remote.details.capacityNote":
    "Allocation is not measured usage or free disk space. Available host capacity is checked when applying and starting.",
  "remote.details.unavailable": "Resource changes require an allocated workspace and an upgraded, reachable host.",
  "remote.details.cpu": "vCPU",
  "remote.details.memory": "RAM (GiB)",
  "remote.details.disk": "Disk (GiB)",
  "remote.details.restartNote":
    "This stops active commands and terminals, then creates a new VM runtime from the same disk. Saved files remain; memory and processes do not. Disk capacity can only increase.",
  "remote.details.confirm": "I have saved my work and agree to interrupt this workspace on all connected clients.",
  "remote.details.retry": "Retry resource change",
  "remote.details.apply": "Stop and apply",
  "files.title": "Files and projects",
  "files.browser.invalidArchive": "The downloaded folder archive is invalid. No files from this transfer were saved.",
  "files.browser.title": "File transfer",
  "files.browser.device": "Local",
  "files.browser.projectRemote": "Remote",
  "files.browser.chooseLocal": "Choose local folder",
  "files.browser.setup": "Choose a local folder for uploads and downloads.",
  "files.browser.changeFolder": "Change folder",
  "files.browser.remotePath": "Remote folder path",
  "files.browser.go": "Go",
  "files.browser.empty": "No files in this folder",
  "files.browser.select": "Select {{name}}",
  "files.browser.selectAll": "Select all",
  "files.browser.selected.one": "{{count}} item selected",
  "files.browser.selected.other": "{{count}} items selected",
  "files.browser.toRemote": "Transfer to remote",
  "files.browser.toDevice": "Transfer to local",
  "files.browser.destination": "Destination: {{path}}",
  "files.browser.reading": "Reading {{name}}…",
  "files.browser.progress": "Saved: {{completed}} / {{total}}",
  "files.browser.progressLabel": "File transfer progress",
  "files.browser.byteProgress.one": "{{completed}} / {{count}} file · {{loaded}} / {{size}} · {{duration}}",
  "files.browser.byteProgress.other": "{{completed}} / {{count}} files · {{loaded}} / {{size}} · {{duration}}",
  "files.browser.summary.one": "{{count}} file · {{size}} · {{duration}}",
  "files.browser.summary.other": "{{count}} files · {{size}} · {{duration}}",
  "files.browser.bytes": "{{value}} B",
  "files.browser.kib": "{{value}} KiB",
  "files.browser.mib": "{{value}} MiB",
  "files.browser.gib": "{{value}} GiB",
  "files.browser.seconds": "{{value}} s",
  "files.browser.minutesSeconds": "{{minutes}}m {{seconds}}s",
  "files.browser.downloadLimit": "Downloads allow up to 1 GiB per file, 20 GiB per transfer and 2,000 entries.",
  "files.browser.uploadLimit": "Limit: 1 GiB per file, 20 GiB per transfer, 2,000 entries.",
  "files.browser.uploadUpgrade": "This server needs an update to upload files. No files were uploaded.",
  "files.browser.uploadRetry.source_changed":
    "An already uploaded local file changed. Rename or move its remote copy to Trash, then retry; or choose another destination.",
  "files.browser.uploadRetry.destination_changed":
    "A remote file changed or could not be verified. Retry to verify it again, or rename or move the remote copy to Trash before retrying. You can also choose another destination.",
  "files.browser.retryUpload": "Retry upload",
  "files.browser.downloadUpgrade": "Update this server to use streaming downloads. No files were downloaded.",
  "files.browser.downloadHttpError": "Could not prepare the download (HTTP {{status}}). No files were downloaded.",
  "files.browser.invalidPlan": "The server returned an invalid file list. No files were downloaded.",
  "files.browser.partial": "Completed files are kept. Check the destination before retrying.",
  "files.browser.retryChanged": "The remote files changed. Choose a new destination to download the updated files.",
  "files.browser.trashWarnings.one": "Trash can needs attention ({{count}} notice). Show details.",
  "files.browser.trashWarnings.other": "Trash can needs attention ({{count}} notices). Show details.",
  "files.browser.cancelled": "Transfer cancelled.",
  "files.browser.error.unsupported": "Folder access is unavailable. Use Chrome or Edge.",
  "files.browser.error.permission_denied":
    "Access to the local folder was denied. Choose the folder again and allow access.",
  "files.browser.error.aborted": "The folder selection was cancelled.",
  "files.browser.error.invalid_path": "Cannot open this folder.",
  "files.browser.error.conflict":
    "A file or folder with the same name already exists at the destination. Choose another destination or rename it first.",
  "files.browser.error.io": "The local file could not be read or saved. Check folder permissions and free space.",
  "files.browser.error.size_mismatch": "The file size changed or the download ended early. The file was not completed.",
  "files.browser.error.too_large": "Downloads allow up to 1 GiB per file, 20 GiB per transfer and 2,000 entries.",
  "files.browser.renameHint": "Select one file to rename.",
  "files.browser.trash": "Trash can",
  "files.browser.trashScope": "Trash can for {{path}}",
  "files.browser.trashEmpty": "Trash can is empty",
  "files.browser.backToFiles": "Back to files",
  "files.browser.restore": "Restore",
  "files.browser.purge": "Delete permanently",
  "files.browser.purgeConfirm.one": "Permanently delete {{count}} item from Trash can? This cannot be undone.",
  "files.browser.purgeConfirm.other": "Permanently delete {{count}} items from Trash can? This cannot be undone.",
  "files.browser.trashed.one": "Moved {{count}} item to Trash can.",
  "files.browser.trashed.other": "Moved {{count}} items to Trash can.",
  "files.browser.restored.one": "Restored {{count}} item to its original location.",
  "files.browser.restored.other": "Restored {{count}} items to their original locations.",
  "files.browser.purged.one": "Permanently deleted {{count}} item.",
  "files.browser.purged.other": "Permanently deleted {{count}} items.",
  "files.browser.renamed": "Renamed {{name}}.",
  "files.browser.mutationPartial": "Any completed changes are kept. Refresh the folder or Trash can before retrying.",
  "files.browser.mutationCancelled": "Operation cancelled. Any completed changes are kept.",
  "files.manage.trash": "Move to trash",
  "files.manage.trashConfirm": "Move {{path}} to Trash can? You can restore it from File transfer.",
  "files.manage.trashUpgrade": "This server needs an update to use Trash can. No files were deleted.",
  "files.transfer.label": "Project files",
  "files.transfer.remote": "Remote",
  "files.transfer.local": "Local",
  "files.transfer.upload": "Upload to remote",
  "files.transfer.download": "Download to local",
  "files.transfer.uploadShort": "Upload",
  "files.transfer.downloadShort": "Download",
  "files.transfer.import": "Import files",
  "files.transfer.importShort": "Import",
  "files.transfer.importFolder": "Import folder",
  "files.transfer.export": "Export ZIP",
  "files.transfer.exportFiles": "Export files",
  "files.transfer.exportShort": "Export",
  "files.transfer.remotePath": "Remote project folder",
  "files.transfer.localPath": "Project folder on this device",
  "files.transfer.remoteFile": "Remote file",
  "files.transfer.localFile": "File on this device",
  "files.transfer.uploadHint":
    "Copy files from this device into the remote project. They become project files, not message attachments. Existing files are not overwritten.",
  "files.transfer.importHint":
    "Copy files into this local project. They become project files, not message attachments. Existing files are not overwritten.",
  "files.transfer.downloadHint":
    "Save a ZIP copy of this folder on this device. Later changes will not sync automatically. Use the Files panel to download individual files.",
  "files.transfer.downloadFileHint":
    "Save a copy of this file on this device. Later changes will not sync automatically.",
  "files.transfer.pendingTarget": "New worktree",
  "files.transfer.disconnected": "Reconnect to this project to transfer files.",
  "files.transfer.pending": "File transfers are available after the new worktree is created.",
  "files.explicit":
    "Transfers run only when you request them. Local and Remote are independent; files are not synchronized. Existing files are never overwritten.",
  "files.destination": "Destination folder inside this project",
  "files.projectRoot": "Project root",
  "files.upload": "Upload files",
  "files.uploadFolder": "Upload folder",
  "files.uploadIntoFolderNamed": "Upload files into {{name}}",
  "files.download": "Download file",
  "files.downloadFolder": "Download folder as ZIP",
  "files.downloadFileNamed": "Download {{name}}",
  "files.downloadFolderNamed": "Download {{name}} as ZIP",
  "files.cancelDownload": "Cancel download of {{name}}",
  "files.downloadCancelled": "Download canceled.",
  "files.downloadFailed": "Download failed",
  "files.limit": "Limit: 64 MiB per file, 128 MiB per transfer, 2,000 entries.",
  "files.prepare": "Prepare a project",
  "files.clone": "Clone a repository",
  "files.git": "Create a Git repository",
  "files.directory": "Create a directory",
  "files.name": "New folder name",
  "files.folderName": "Project folder",
  "files.repository": "HTTPS repository URL",
  "files.repositoryPlaceholder": "https://github.com/owner/repository.git",
  "files.token": "Access token (optional, for private repositories)",
  "files.tokenNote":
    "The token is used for this clone only and is not saved. Future Git operations need separate authentication.",
  "files.prepareAction": "Create and open",
  "files.failed": "File operation failed. Check the remote connection and retry.",
  "files.cancelled": "Transfer cancelled. Completed files remain; inspect the destination before retrying.",
  "files.complete": "Transfer complete.",
  "files.batchProgress": "Saved: {{completed}} / {{total}} · Uploaded: {{percent}}%",
  "files.downloadRequested":
    "Download requested: {{name}} ({{bytes}} B). Complete the save dialog or check your downloads. This does not confirm a local save.",
  "prompt.paste.tooLarge.title": "Pasted text is too large",
  "prompt.attachment.preview.source": "Preview of the saved pasted text.",
  "prompt.attachment.preview.truncated":
    "Preview limited to the first {{limit}} characters. The uploaded file is unchanged.",
  "prompt.attachment.preview.failed": "The saved text could not be loaded.",
  "prompt.paste.tooLarge.description":
    "Paste up to 10 MiB at a time, or attach a text file. Nothing was inserted or sent.",
  "prompt.toast.uploading.failed": "Upload failed — content kept",
  "prompt.toast.uploading.retry": "Retry upload",
  "files.progress": "{{name}} — {{index}} / {{total}}, {{percent}}%",
  "files.context": "Upload or download here",
  "remote.localUnavailable": "Local OMM service is unavailable.",
  "remote.failed": "Remote could not start. Retry shortly.",
  "remote.reconnecting": "Remote connection interrupted. Retrying…",
  "remote.sleeping": "Remote is sleeping. Select Remote to resume.",
  "remote.resume": "Resume Remote",
  "remote.local": "Local",
  "remote.remote": "Remote",
  "remote.switching": "Switching…",
  "remote.startup.connecting": "Connecting to cloud workspace…",
  "remote.startup.preparing": "Preparing cloud workspace…",
  "remote.startup.starting": "Starting cloud workspace…",
  "remote.startup.stopping": "Waiting for workspace to stop…",
  "remote.startup.ready": "Opening cloud workspace…",
  "remote.startup.timeout": "The cloud workspace did not become ready within 5 minutes. Select Remote to retry.",
  ...DESKTOP_NATIVE_ENGLISH,
  ...UI_PREVIEW_ENGLISH,
  "composer.permissions.trigger": "Permissions: {{mode}}",
  "toast.permissions.session.failed.description":
    "Auto-approval failed. This exploration now asks for approval so you can review the pending request.",
  "session.edit.unknown.title": "Could not confirm whether your changes were sent",
  "session.edit.unknown.description": "Your edited question is kept. Check the result before sending another change.",
  "session.edit.unknown.action": "Retry safely",
  "session.edit.restoreFailed": "The original exploration could not be fully restored. Your edit is kept.",
  "session.edit.restoreAction": "Restore original exploration",
  "composer.permissions.ask": "Ask before actions",
  "composer.permissions.ask.description": "Review permission requests before allowing actions.",
  "composer.permissions.auto": "Auto-approve",
  "composer.permissions.auto.description":
    "Automatically allow permission requests, including file changes and commands, without asking each time.",
  "composer.permissions.scope.session": "Only this exploration.",
  "composer.model.title": "Model",
  "composer.model.context.one": "Context: {{limit}} token",
  "composer.model.context.other": "Context: {{limit}} tokens",
  "model.context.tokens.one": "{{limit}} token",
  "model.context.tokens.other": "{{limit}} tokens",
  "composer.model.reasoning.title": "Thinking effort",
  "composer.model.reasoning.description": "Higher effort gives the model more room to think.",
  "composer.model.reasoning.none": "Off",
  "composer.model.reasoning.minimal": "Minimal",
  "composer.model.reasoning.low": "Low",
  "composer.model.reasoning.medium": "Medium",
  "composer.model.reasoning.high": "High",
  "composer.model.reasoning.xhigh": "Extra high",
  "composer.model.reasoning.max": "Max",
  "composer.model.reasoning.ultra": "Ultra",
  "settings.permissions.session.description":
    "Choose how permission requests are handled in each exploration’s input box. New explorations auto-approve requests.",
  "toast.permissions.session.auto.description":
    "Permission requests in this exploration will be approved automatically.",
  "toast.permissions.session.ask.description": "Permission requests in this exploration will require your approval.",
  "session.edit.continueFailed.title": "Your changes were sent, but the exploration could not continue",
  "session.edit.continueFailed.description": "Your edited question is saved. Continue without sending it again.",
  "session.edit.pendingRevert":
    "Finish or undo the pending revert before replacing a message. You can also send the edit in a new exploration.",
  "sair.navigation.layout.title": "Exploration navigation",
  "sair.navigation.layout.description": "Open explorations in a drawer or keep them in a sidebar",
  "sair.navigation.layout.drawer": "Drawer",
  "sair.navigation.layout.sidebar": "Sidebar",
  "sair.navigation.title": "SAIR navigation",
  "sair.navigation.new": "New Exploration",
  "sair.navigation.projects": "Projects",
  "project.entry.local": "Local project",
  "project.entry.addLocal": "Add local project",
  "project.default.name": "Exploration",
  "project.default.createFailed": "Could not create Exploration",
  "project.entry.currentServer": "Project on this server",
  "project.entry.addCurrentServer": "Add project on this server",
  "project.entry.remote": "Remote project",
  "project.entry.addRemote": "Add remote project",
  "project.rename.unavailable":
    "Folder renaming is unavailable on this server (HTTP {{status}}). The server for this project may need to be updated.",
  "project.rename.failedStatus": "Could not rename this folder (HTTP {{status}}). Check the server and try again.",
  "project.remote.loading": "Connecting to remote projects",
  "project.remote.disconnected": "Remote project connection inactive",
  "project.remote.choose": "Available projects",
  "project.remote.new": "New project",
  "project.remote.name": "Project name",
  "project.remote.create": "Create project",
  "project.remote.loadFailed": "Could not load remote projects. Check the connection and try again.",
  "project.remote.createFailed": "Could not create the project. Check the name or choose another one.",
  "sair.navigation.sessions": "Explorations",
  "sair.navigation.search": "Search",
  "session.navigation.recent": "Recent explorations",
  "session.navigation.pinned": "Pinned",
  "session.navigation.noUnpinned": "All recent explorations are pinned",
  "session.navigation.noUnpinnedProjects": "All projects are pinned",
  "session.navigation.pin": "Pin exploration",
  "session.navigation.unpin": "Unpin exploration",
  "session.navigation.pinProject": "Pin project",
  "session.navigation.unpinProject": "Unpin project",
  "session.navigation.options": "Options for {{title}}",
  "session.navigation.pinnedOptions": "Pinned options",
  "session.navigation.moveUp": "Move up",
  "session.navigation.moveDown": "Move down",
  "session.navigation.sort": "Sort explorations",
  "session.navigation.sort.manual": "Manual order",
  "session.navigation.sort.attention": "Priority",
  "session.navigation.sort.updated": "Last updated",
  "session.navigation.dropToPin": "Drop here to pin",
  "session.navigation.unavailable": "Currently unavailable",
  "session.navigation.opened": "Opened",
  "session.navigation.search": "Search explorations",
  "session.navigation.library": "Exploration library",
  "session.navigation.toggle": "Toggle sidebar",
  "session.navigation.collapse": "Hide sidebar",
  "session.navigation.expand": "Show sidebar",
  "session.navigation.noServer": "Add a server to view recent explorations",
  "session.navigation.disconnected": "Disconnected. Recent explorations will refresh when reconnected.",
  "session.navigation.loadFailed": "Could not load recent explorations.",
  "session.navigation.retry": "Try again",
  "session.navigation.noRecent": "No recent explorations",
  "session.navigation.noProjects": "No projects yet",
  "session.navigation.newInProject": "New exploration in {{project}}",
  "session.navigation.projectOptions": "More options for {{project}}",
  "project.remote.title": "Add remote project",
  "project.remote.description": "Choose an existing folder or create a project.",
  "project.remote.createTitle": "New remote project",
  "project.remote.createDescription": "Create a folder in your remote workspace.",
  "project.remote.emptyTitle": "Create your first remote project",
  "project.remote.search": "Search projects…",
  "project.remote.noMatches": "No matching projects",
  "project.remote.noMatchesDescription": "Try a different name or create a project.",
  "project.remote.added": "Added",
  "project.remote.back": "Back to projects",
  "project.remote.invalidName": "Use a single folder name without slashes or control characters.",
  "project.remote.duplicateName": "A folder with this name already exists.",
  "project.remote.creating": "Creating project…",
  "session.navigation.projectsOptions": "Project list options",
  "session.navigation.removeProject.title": "Remove “{{name}}” from Projects?",
  "session.navigation.removeProject.description":
    "The folder and its explorations will remain available. You can add the project again at any time.",
  "session.navigation.removeProject.done": "Removed “{{name}}” from Projects",
  "session.navigation.undo": "Undo",
  "project.entry.description": "Choose where your project is stored.",
  "session.navigation.removeProject": "Remove from Projects",
  "home.recentlyRemoved": "Recently removed",
  "session.navigation.location.local": "Local",
  "session.title.child": "Child exploration",
  "session.archive.unavailable": "Exploration archiving is unavailable",
  "session.navigation.attention": "Needs attention",
  "session.navigation.running": "Running",
  "session.navigation.unread": "New reply",
  "session.navigation.updated": "Updated {{time}}",
  "sair.workspace.title": "Workspace",
  "sair.workspace.resize": "Resize Workspace",
  "workspace.changes": "Changes",
  "workspace.pendingProject": "This project will be created when you send your first message.",
  "workspace.pendingWorktree": "This worktree will be created when you send your first message.",
  "workspace.notCreated": "Not created yet",
  "workspace.chooseProject": "Choose a project",
  "workspace.useMain": "Use the existing project",
  "workspace.worktreeTools": "Tool presets come from {{project}} and apply when the worktree is created.",
  "workspace.environment": "Environment",
  "workspace.local": "Local",
  "workspace.remote": "Remote",
  "workspace.terminalEmpty": "No terminals open",
  "workspace.terminalFailed": "Could not connect to this terminal.",
  "workspace.changesScope": "Changes in this workspace",
  "workspace.find": "Find in exploration",
  "workspace.changesUnavailable": "Changes are unavailable. Reconnect or try again.",
  "workspace.terminalCreateFailed": "Could not create a terminal. Try again.",
  "files.manage.title": "Manage files",
  "files.manage.downloadHint": "Select a file to download it, or open a folder to download that folder as a ZIP.",
  "files.manage.upgrade":
    "This server needs an update to edit, rename or delete files. Upload and download remain available.",
  "files.manage.requestFailedStatus": "Could not complete the file request (HTTP {{status}}).",
  "files.manage.unsaved": "Save or discard your changes before opening another file or folder.",
  "files.manage.unsavedLabel": "Unsaved changes",
  "files.manage.invalidName": "Enter a file name without slashes, parent paths or empty segments.",
  "files.manage.refresh": "Refresh",
  "files.manage.offline": "Reconnect to read or change files. Loaded content and unsaved edits are kept.",
  "files.manage.parent": "Up one folder",
  "files.manage.filter": "Filter this folder",
  "files.manage.open": "Open in workspace",
  "files.manage.edit": "Edit file",
  "files.manage.save": "Save changes",
  "files.manage.discard": "Discard changes",
  "files.manage.name": "File name",
  "files.manage.deleteConfirm": "Permanently delete {{path}}? This cannot be undone.",
  "files.manage.discardConfirm": "Discard your unsaved changes to {{path}} and reload the current file?",
  "files.manage.editor": "Edit {{path}}",
  "files.manage.textLimit": "Editing is available for UTF-8 text files up to 1 MiB. You can still download this file.",
  "workspace.unavailableOffline": "This content has not been loaded. Reconnect to view it.",
  "workspace.details": "Details",
  "workspace.offline": "Disconnected. Showing cached content. Reconnect to make changes.",
  "workspace.terminal.empty": "No terminal is open in this workspace.",
  "sair.workspace.close": "Close workspace",
  "sair.account.menu": "SAIR account",
  "sair.account.profile": "Open SAIR profile",
  "session.view.backToConversation": "Back to exploration",
  "sair.server": "SAIR service",
  "sair.server.add": "Add service",
  "sair.server.edit": "Edit connection",
  "sair.connection.lost": "Connection lost. Reconnecting…",
  "sair.checking": "Checking your sign-in status…",
  "sair.opening.title": "Opening SAIR",
  "sair.workspace.preparing": "Preparing your workspace…",
  "sair.signIn.copy": "Copy code",
  "sair.signIn.copyFailed": "Could not copy the code. Select it to copy manually.",
  "sair.check.slow": "This is taking longer than usual.",
  "sair.check.failed": "Unable to check sign-in",
  "sair.check.failed.description": "Check your connection and try again.",
  "sair.connection.missing": "Connect to an SAIR service to continue.",
  "sair.connection.settings": "Connection settings",
  "sair.retry": "Try again",
  "sair.signIn.title": "Sign in to SAIR",
  "sair.logo": "SAIR",
  "sair.signIn.description": "Sign in to start using SAIR.",
  "sair.signIn.browserHint": "Continue in your browser, then return to your workspace.",
  "sair.signIn.intro": "Sign in to your workspace.",
  "sair.signIn.heading": "Sign in",
  "sair.signIn.pendingTitle": "Check your browser",
  "sair.signIn.continue": "Continue in browser",
  "sair.web.continue": "Sign in with SAIR",
  "sair.web.opening": "Redirecting…",
  "sair.web.pendingTitle": "Completing sign-in",
  "sair.web.waiting": "Confirm your account on SAIR ID. We will finish signing in when you return.",
  "sair.web.completing": "Checking your sign-in. This page will continue automatically.",
  "sair.web.signingIn": "Signing you in…",
  "sair.web.verifying": "Verifying your SAIR account.",
  "sair.web.cancel": "Cancel",
  "sair.web.returnInvalid": "This sign-in return is no longer valid. Start again from OMM.",
  "sair.web.expired": "This sign-in request has expired. Start again from OMM.",
  "sair.web.storageFailed": "Allow this site to save browser data, then start sign-in again.",
  "sair.signIn.action": "Continue with SAIR",
  "sair.signIn.opening": "Opening sign-in…",
  "sair.signIn.waiting": "Finish signing in in your browser.",
  "sair.signIn.code": "Confirmation code",
  "sair.signIn.codeHint": "Check that the account page shows this code before you approve the connection.",
  "sair.signIn.open": "Open sign-in page",
  "sair.signIn.cancel": "Cancel sign-in",
  "sair.signIn.expired": "This sign-in request expired. Start again to get a new code.",
  "sair.signIn.sessionExpired": "Your session has expired. Sign in again to continue.",
  "sair.signIn.denied": "The connection was declined. You can start again when you are ready.",
  "sair.signIn.failed": "We could not complete the request. Check your connection and try again.",
  "sair.access.denied.title": "OMM access is unavailable",
  "sair.access.denied.description":
    "This SAIR account does not have OMM access. Contact an administrator or sign in with another account. After access is restored, start a new sign-in. Your SAIR website session, saved history and files are kept.",
  "sair.access.signIn": "Start a new sign-in",
  "sair.access.cleanup":
    "OMM access was removed, but the saved credentials could not be cleared. Access is blocked. Retry signing out before restarting; your history and files are kept.",
  "sair.access.action.title": "Action needed to continue",
  "sair.access.email.description":
    "Your current SAIR email must be verified before OMM access can be granted. Contact a SAIR administrator for help, then check again. You can also open the sign-in page to switch accounts.",
  "sair.access.identity.description":
    "SAIR could not uniquely match this email to an account. Ask an administrator to resolve the account conflict, then check again.",
  "sair.access.paused": "Authorization is paused. This code can be used again until it expires.",
  "sair.access.recheck": "Check again after resolving",
  "sair.signIn.scope": "Your account is shared by the clients connected to the selected SAIR service.",
  "sair.account.avatar": "SAIR account avatar",
  "sair.logout.action": "Sign out",
  "sair.logout.signingOut": "Signing out",
  "sair.logout.signingOut.description": "Stopping running tasks before signing out.",
  "sair.logout.failed.title": "Sign-out incomplete",
  "sair.logout.incomplete": "You are signed out locally, but we could not confirm that SAIR revoked this connection.",
  "sair.logout.storageFailed":
    "Could not remove this SAIR service's saved SAIR session. Retry signing out before restarting.",
  "sair.models.unavailable": "You are signed in. Models are not ready yet; retry to load your model access.",
  "sair.models.preparing": "You are signed in. Preparing model access…",
  "dialog.provider.omm.note": "Model access through the OMM gateway",
  "ssh.label": "SSH",
  "ssh.offline": "Not connected to {{host}}. Your draft is preserved; remote work may still be running.",
  "ssh.placeholder": "ssh user@example.com",
  "ssh.add": "Add SSH server",
  "ssh.server.menu.label": "SSH server",
  "ssh.target": "Host or SSH command",
  "ssh.connect": "Connect",
  "ssh.connectTo": "Connect to {{host}}",
  "ssh.authenticate": "SSH authentication",
  "ssh.action.authenticate": "Authenticate",
  "ssh.session.disconnected": "SSH connection inactive",
  "ssh.session.connecting": "Connecting to SSH server",
  "ssh.session.reconnectDescription":
    "Reconnect to view this exploration and continue working. Your remote exploration is preserved.",
  "ssh.session.reconnect": "Reconnect",
  "ssh.authenticationRequired": "Authentication required for {{host}}",
  "ssh.trust": "Trust and connect",
  "ssh.continue": "Continue",
  "ssh.retry": "Retry",
  "ssh.update": "Update and reconnect",
  "ssh.openProject": "Open project",
  "ssh.project": "Open project on {{host}}",
  "ssh.disconnect": "Disconnect",
  "ssh.forget": "Forget connection",
  "ssh.stage.disconnected": "Disconnected. The remote server is left running.",
  "ssh.stage.connecting": "Connecting over SSH…",
  "ssh.stage.checking": "Checking OMM…",
  "ssh.stage.downloading": "Downloading server…",
  "ssh.stage.uploading": "Uploading server…",
  "ssh.stage.starting": "Connecting to OMM…",
  "ssh.stage.ready": "Connected",
  "ssh.stage.authentication": "Authentication required",
  "ssh.stage.incompatible": "Server update required",
  "ssh.stage.failed": "Connection failed",
  "ssh.error.input":
    "Enter a host or SSH connection command. Remote commands and unsupported SSH options aren’t allowed.",
  "ssh.error.connection": "Could not establish the SSH connection. Check your network and SSH configuration.",
  "ssh.error.platform":
    "This remote platform is not supported. Automatic setup currently requires Linux or macOS on x64 or arm64.",
  "ssh.error.version": "The remote service must match this Desktop version before connecting.",
  "ssh.error.install":
    "Could not install the remote server. Check connectivity, disk space, and that tar is installed.",
  "ssh.error.unpublished":
    "This Desktop version has no published remote server. For development builds, install and start V2 on the host, then retry.",
  "ssh.error.service": "SSH connected, but the OMM server did not become ready.",
  "ssh.error.host-key":
    "The host’s identity could not be verified. Verify its fingerprint before updating your SSH known hosts.",
  "ssh.error.ssh-missing": "OpenSSH was not found. Install an OpenSSH client and ensure ssh is available on PATH.",
  "session.location.unavailable": "Exploration location unavailable",
  "session.location.description": "Choose another directory to continue this exploration.",
  "session.location.choose": "Choose directory",
  "session.location.worktree": "Choose worktree",
  "session.location.worktreesFailed": "Failed to load worktrees",
  "session.location.moving": "Moving exploration…",
  "command.category.suggested": "Suggested",
  "command.category.view": "View",
  "command.category.project": "Project",
  "command.category.provider": "Provider",
  "command.category.server": "Server",
  "command.category.session": "Exploration",
  "command.category.theme": "Theme",
  "command.category.language": "Language",
  "command.category.file": "File",
  "command.category.context": "Context",
  "command.category.terminal": "Terminal",
  "command.category.model": "Model",
  "command.category.mcp": "MCP",
  "command.category.agent": "Agent",
  "command.category.permissions": "Permissions",
  "command.category.workspace": "Worktree",
  "command.category.settings": "Settings",
  "command.logs.export": "Export logs",
  "command.debugBar.toggle": "Toggle debug bar",

  "theme.scheme.system": "System",
  "theme.scheme.light": "Light",
  "theme.scheme.dark": "Dark",

  "command.sidebar.toggle": "Toggle sidebar",
  "command.project.open": "Open project",
  "command.project.previous": "Previous project",
  "command.project.next": "Next project",
  "command.project.index": "Switch to project {{index}}",
  "command.project.copyID": "Copy Project ID",
  "command.provider.connect": "Connect provider",
  "command.server.switch": "Switch server",
  "command.settings.open": "Open settings",
  "command.session.previous": "Previous exploration",
  "command.session.next": "Next exploration",
  "command.session.previous.unseen": "Previous unread exploration",
  "command.session.next.unseen": "Next unread exploration",
  "command.session.archive": "Archive exploration",
  "command.session.location.cycle": "Cycle exploration location",

  "command.palette": "Command palette",

  "command.theme.cycle": "Cycle theme",
  "command.theme.set": "Use theme: {{theme}}",
  "command.theme.scheme.cycle": "Cycle color scheme",
  "command.theme.scheme.set": "Use color scheme: {{scheme}}",

  "command.language.cycle": "Cycle language",
  "command.language.set": "Use language: {{language}}",

  "command.session.new": "New exploration",
  "command.file.open": "Open file",
  "command.browser.open": "Open browser",
  "command.browser.reload": "Reload browser page",
  "command.tab.close": "Close tab",
  "command.tab.reopenClosed": "Reopen closed tab",
  "command.context.addSelection": "Add selection to context",
  "command.context.addSelection.description": "Add selected lines from the current file",
  "command.input.focus": "Focus input",
  "command.terminal.toggle": "Toggle terminal",
  "command.fileTree.toggle": "Toggle file tree",
  "command.review.toggle": "Toggle review",
  "command.session.summary.toggle": "Toggle summary",
  "command.terminal.new": "New terminal",
  "command.terminal.new.description": "Create a new terminal tab",
  "command.steps.toggle": "Toggle steps",
  "command.steps.toggle.description": "Show or hide steps for the current message",
  "command.message.previous": "Previous message",
  "command.message.previous.description": "Go to the previous user message",
  "command.message.next": "Next message",
  "command.message.next.description": "Go to the next user message",
  "command.model.choose": "Choose model",
  "command.model.choose.description": "Select a different model",
  "command.mcp.toggle": "Toggle MCPs",
  "command.mcp.toggle.description": "Toggle MCPs",
  "command.agent.cycle": "Cycle agent",
  "command.agent.cycle.description": "Switch to the next agent",
  "command.agent.cycle.reverse": "Cycle agent backwards",
  "command.agent.cycle.reverse.description": "Switch to the previous agent",
  "command.model.variant.cycle": "Cycle thinking effort",
  "command.model.variant.cycle.description": "Switch to the next effort level",
  "command.prompt.mode.shell": "Shell",
  "command.prompt.mode.normal": "Prompt",
  "command.permissions.autoaccept.enable": "Auto-accept permissions",
  "command.permissions.autoaccept.disable": "Stop auto-accepting permissions",
  "command.workspace.toggle": "Toggle worktrees",
  "command.workspace.toggle.description": "Enable or disable multiple worktrees in the sidebar",
  "command.session.undo": "Undo",
  "command.session.undo.description": "Undo the last message",
  "command.session.redo": "Redo",
  "command.session.redo.description": "Redo the last undone message",
  "command.session.compact": "Compact exploration",
  "command.session.compact.description": "Summarize the exploration to reduce context size",
  "command.session.fork": "Fork from message",
  "command.session.fork.description": "Create a new exploration from a previous message",
  "command.session.export": "Export exploration",
  "command.session.export.description": "Export the full exploration transcript as JSON",
  "command.session.import": "Import exploration",
  "command.session.copyID": "Copy Exploration ID",

  "palette.search.placeholder": "Search files, commands, and explorations",
  "palette.search.placeholder.home": "Search commands and explorations",
  "palette.empty": "No results found",
  "palette.group.commands": "Commands",
  "palette.group.files": "Files",

  "dialog.provider.search.placeholder": "Search providers",
  "dialog.provider.empty": "No providers found",
  "dialog.provider.group.popular": "Popular",
  "dialog.provider.group.other": "Other",
  "dialog.provider.custom.label": "Custom OpenAI-compatible provider",
  "dialog.provider.tag.recommended": "Recommended",
  "dialog.provider.opencode.note": "Curated models including Claude, GPT, Gemini and more",
  "dialog.provider.opencode.tagline": "Reliable optimized models",
  "dialog.provider.opencodeGo.tagline": "Low cost subscription for everyone",
  "dialog.provider.anthropic.note": "Direct access to Claude models via API key",
  "dialog.provider.copilot.note": "AI models for coding assistance via GitHub Copilot",
  "dialog.provider.openai.note": "GPT models for fast, capable general AI tasks",
  "dialog.provider.google.note": "Gemini models for fast, structured responses",
  "dialog.provider.openrouter.note": "Access all supported models from one provider",
  "dialog.provider.vercel.note": "Unified access to AI models with smart routing",

  "dialog.model.select.title": "Select model",
  "dialog.model.search.placeholder": "Search models",
  "dialog.model.empty": "No model results",
  "dialog.model.manage": "Manage models",
  "dialog.model.manage.description": "Customize which models appear in the model selector.",
  "dialog.model.manage.provider.toggle": "Toggle all {{provider}} models",

  "dialog.model.unpaid.freeModels.title": "Available models",
  "dialog.model.unpaid.addMore.title": "Add more models from popular providers",
  "dialog.model.unpaid.viewMoreProviders": "See 70+ more providers",

  "dialog.provider.viewAll": "Show more providers",

  "provider.connect.title": "Connect {{provider}}",
  "provider.connect.title.anthropicProMax": "Login with Anthropic",
  "provider.connect.selectMethod": "Select login method for {{provider}}.",
  "provider.connect.method.apiKey": "API key",
  "provider.connect.method.browser": "Browser",
  "provider.connect.method.headless": "Headless",
  "provider.connect.status.inProgress": "Authorization in progress…",
  "provider.connect.status.waiting": "Waiting for authorization…",
  "provider.connect.status.failed": "Authorization failed: {{error}}",
  "provider.connect.apiKey.description":
    "Enter your {{provider}} API key to connect your account and use {{provider}} models in OMM.",
  "provider.connect.apiKey.label": "{{provider}} API key",
  "provider.connect.apiKey.placeholder": "API key",
  "provider.connect.apiKey.required": "API key is required",
  "provider.connect.opencodeZen.line1":
    "OpenCode Zen gives you access to a curated set of reliable optimized models for coding agents.",
  "provider.connect.opencodeZen.line2":
    "With a single API key you'll get access to models such as Claude, GPT, Gemini, GLM and more.",
  "provider.connect.opencodeZen.visit.prefix": "Visit ",
  "provider.connect.opencodeZen.visit.link": "opencode.ai/zen",
  "provider.connect.opencodeZen.visit.suffix": " to collect your API key.",
  "provider.connect.oauth.code.visit.prefix": "Visit ",
  "provider.connect.oauth.code.visit.link": "this link",
  "provider.connect.oauth.code.visit.suffix":
    " to collect your authorization code to connect your account and use {{provider}} models in OMM.",
  "provider.connect.oauth.code.label": "{{method}} authorization code",
  "provider.connect.oauth.code.placeholder": "Authorization code",
  "provider.connect.oauth.code.required": "Authorization code is required",
  "provider.connect.oauth.code.invalid": "Invalid authorization code",
  "provider.connect.oauth.auto.visit.prefix": "Visit ",
  "provider.connect.oauth.auto.visit.link": "this link",
  "provider.connect.oauth.auto.visit.suffix":
    " and enter the code below to connect your account and use {{provider}} models in OMM.",
  "provider.connect.oauth.auto.confirmationCode": "Confirmation code",
  "provider.connect.toast.connected.title": "{{provider}} connected",
  "provider.connect.toast.connected.description": "{{provider}} models are now available to use.",

  "provider.custom.title": "Custom provider",
  "provider.custom.unavailable": "Custom providers are unavailable on this server",
  "provider.custom.description.prefix": "Configure an OpenAI-compatible provider. See the ",
  "provider.custom.description.link": "provider config docs",
  "provider.custom.description.suffix": ".",
  "provider.custom.field.providerID.label": "Provider ID",
  "provider.custom.field.providerID.placeholder": "myprovider",
  "provider.custom.field.providerID.description": "Lowercase letters, numbers, hyphens, or underscores",
  "provider.custom.field.name.label": "Display name",
  "provider.custom.field.name.placeholder": "My AI Provider",
  "provider.custom.field.baseURL.label": "Base URL",
  "provider.custom.field.baseURL.placeholder": "https://api.myprovider.com/v1",
  "provider.custom.field.apiKey.label": "API key",
  "provider.custom.field.apiKey.placeholder": "API key",
  "provider.custom.field.apiKey.description": "Optional. Leave empty if you manage auth via headers.",
  "provider.custom.models.label": "Models",
  "provider.custom.models.id.label": "ID",
  "provider.custom.models.id.placeholder": "model-id",
  "provider.custom.models.name.label": "Name",
  "provider.custom.models.name.placeholder": "Display Name",
  "provider.custom.models.remove": "Remove model",
  "provider.custom.models.add": "Add model",
  "provider.custom.headers.label": "Headers (optional)",
  "provider.custom.headers.key.label": "Header",
  "provider.custom.headers.key.placeholder": "Header-Name",
  "provider.custom.headers.value.label": "Value",
  "provider.custom.headers.value.placeholder": "value",
  "provider.custom.headers.remove": "Remove header",
  "provider.custom.headers.add": "Add header",
  "provider.custom.error.providerID.required": "Provider ID is required",
  "provider.custom.error.providerID.format": "Use lowercase letters, numbers, hyphens, or underscores",
  "provider.custom.error.providerID.exists": "That provider ID already exists",
  "provider.custom.error.name.required": "Display name is required",
  "provider.custom.error.baseURL.required": "Base URL is required",
  "provider.custom.error.baseURL.format": "Must start with http:// or https://",
  "provider.custom.error.required": "Required",
  "provider.custom.error.duplicate": "Duplicate",

  "provider.disconnect.toast.disconnected.title": "{{provider}} disconnected",
  "provider.disconnect.toast.disconnected.description": "{{provider}} models are no longer available.",

  "model.tag.free": "Free",
  "model.tag.latest": "Latest",
  "model.provider.anthropic": "Anthropic",
  "model.provider.openai": "OpenAI",
  "model.provider.google": "Google",
  "model.provider.xai": "xAI",
  "model.provider.meta": "Meta",
  "model.input.text": "text",
  "model.input.image": "image",
  "model.input.audio": "audio",
  "model.input.video": "video",
  "model.input.pdf": "pdf",
  "model.tooltip.allows": "Allows: {{inputs}}",
  "model.tooltip.context.label": "Context",
  "model.tooltip.inputs": "Inputs",
  "model.tooltip.model": "Model",
  "model.tooltip.provider": "Provider",
  "model.tooltip.reasoning": "Reasoning",
  "model.tooltip.reasoning.allowed": "Allows reasoning",
  "model.tooltip.reasoning.none": "No reasoning",
  "model.tooltip.context": "Context limit {{limit}}",

  "common.search.placeholder": "Search",
  "common.goBack": "Navigate back",
  "common.goForward": "Navigate forward",
  "common.loading": "Loading",
  "common.loading.ellipsis": "…",
  "common.cancel": "Cancel",
  "common.clear": "Clear",
  "common.open": "Open",
  "common.connect": "Connect",
  "common.disconnect": "Disconnect",
  "common.continue": "Continue",
  "common.submit": "Submit",
  "common.save": "Save",
  "common.saving": "Saving…",
  "common.default": "Default",
  "common.attachment": "attachment",

  "prompt.placeholder.shell": "Enter shell command… {{example}}",
  "prompt.placeholder.normal": 'Explore a problem or conjecture… "{{example}}"',
  "prompt.placeholder.simple": "Explore a problem or conjecture…",
  "prompt.placeholder.summarizeComments": "Summarize comments…",
  "prompt.placeholder.summarizeComment": "Summarize comment…",
  "prompt.mode.shell": "Shell",
  "prompt.mode.normal": "Prompt",
  "prompt.mode.shell.exit": "esc to exit",
  "session.child.promptDisabled": "Subagent explorations cannot be prompted.",
  "session.child.backToParent": "Back to main exploration.",

  "prompt.example.1": "Fix a TODO in the codebase",
  "prompt.example.2": "What is the tech stack of this project?",
  "prompt.example.3": "Fix broken tests",
  "prompt.example.4": "Explain how authentication works",
  "prompt.example.5": "Find and fix security vulnerabilities",
  "prompt.example.6": "Add unit tests for the user service",
  "prompt.example.7": "Refactor this function to be more readable",
  "prompt.example.8": "What does this error mean?",
  "prompt.example.9": "Help me debug this issue",
  "prompt.example.10": "Generate API documentation",
  "prompt.example.11": "Optimize database queries",
  "prompt.example.12": "Add input validation",
  "prompt.example.13": "Create a new component for…",
  "prompt.example.14": "How do I deploy this project?",
  "prompt.example.15": "Review my code for best practices",
  "prompt.example.16": "Add error handling to this function",
  "prompt.example.17": "Explain this regex pattern",
  "prompt.example.18": "Convert this to TypeScript",
  "prompt.example.19": "Add logging throughout the codebase",
  "prompt.example.20": "What dependencies are outdated?",
  "prompt.example.21": "Help me write a migration script",
  "prompt.example.22": "Implement caching for this endpoint",
  "prompt.example.23": "Add pagination to this list",
  "prompt.example.24": "Create a CLI command for…",
  "prompt.example.25": "How do environment variables work here?",

  "prompt.popover.emptyResults": "No matching results",
  "prompt.popover.emptyCommands": "No matching commands",
  "prompt.dropzone.label": "Drop images, PDFs, or text files here",
  "prompt.dropzone.file.label": "Drop to @mention file",
  "prompt.slash.badge.custom": "custom",
  "prompt.slash.badge.skill": "skill",
  "prompt.slash.badge.mcp": "mcp",
  "prompt.context.active": "active",
  "prompt.context.includeActiveFile": "Include active file",
  "prompt.context.removeActiveFile": "Remove active file from context",
  "prompt.context.removeFile": "Remove file from context",
  "prompt.action.attachFile": "Add files",
  "prompt.menu.addImagesAndFiles": "Add files and more",
  "prompt.menu.imagesAndFiles": "Images and files",
  "prompt.menu.commands": "Commands",
  "prompt.menu.context": "Context",
  "prompt.menu.shellCommand": "Shell command",
  "prompt.attachment.remove": "Remove attachment",
  "prompt.action.send": "Send",
  "prompt.action.stop": "Stop",

  "prompt.toast.attachmentDuplicate.title": "This file has already been uploaded",
  "prompt.toast.uploading.percent": "{{percent}}%",
  "prompt.toast.uploading.cancel": "Cancel upload",
  "prompt.toast.uploadFailed.title": "Upload failed",
  "prompt.toast.modelAgentRequired.title": "Select an agent and model",
  "prompt.toast.modelAgentRequired.description": "Choose an agent and model before sending a prompt.",
  "prompt.toast.worktreeCreateFailed.title": "Failed to create worktree",
  "prompt.toast.sessionCreateFailed.title": "Failed to create exploration",
  "prompt.toast.shellSendFailed.title": "Failed to send shell command",
  "prompt.toast.commandSendFailed.title": "Failed to send command",
  "prompt.toast.promptSendFailed.title": "Failed to send prompt",
  "prompt.toast.promptSendFailed.description": "Unable to retrieve exploration",

  "dialog.mcp.title": "MCPs",
  "dialog.mcp.description": "{{enabled}} of {{total}} enabled",
  "dialog.mcp.empty": "No MCPs configured",

  "dialog.lsp.empty": "LSPs auto-detected from file types",
  "dialog.plugins.empty": "Plugins configured in opencode.json",

  "mcp.status.connected": "connected",
  "mcp.status.failed": "failed",
  "mcp.status.needs_auth": "needs auth",
  "mcp.status.disabled": "disabled",
  "mcp.auth.clickToAuthenticate": "Click to authenticate",
  "mcp.auth.interactiveForm": "MCP server {{name}} requires an interactive authentication form",

  "dialog.fork.empty": "No messages to fork from",

  "dialog.directory.search.placeholder": "Search folders",
  "dialog.directory.empty": "No folders found",
  "dialog.directory.action.selectFile": "Select file",
  "dialog.directory.action.selectFolder": "Select folder",
  "dialog.directory.root": "Root",
  "dialog.directory.parent": "Parent",
  "dialog.directory.readError": "Unable to read this folder",

  "app.server.unreachable": "Could not reach {{server}}",
  "app.server.retrying": "Retrying automatically…",
  "app.server.otherServers": "Other servers",

  "dialog.server.title": "Servers",
  "dialog.server.description": "Switch which OMM server this app connects to.",
  "dialog.server.search.placeholder": "Search servers",
  "dialog.server.empty": "No servers yet",
  "dialog.server.add.title": "Add server",
  "dialog.server.add.url": "Server address",
  "dialog.server.add.placeholder": "http://localhost:4096",
  "dialog.server.add.error": "Could not connect to server",
  "dialog.server.add.checking": "Checking…",
  "dialog.server.add.button": "Add server",
  "dialog.server.add.name": "Server name (optional)",
  "dialog.server.add.namePlaceholder": "Localhost",
  "dialog.server.add.password": "Password",
  "dialog.server.add.passwordPlaceholder": "password",

  "server.connect.title": "Connect to a server",
  "server.connect.description": "Enter your server address and password to get started.",
  "server.connect.button": "Connect",
  "server.connect.address.invalid": "Enter a valid HTTP or HTTPS server address.",
  "server.connect.failed": "Could not connect. Check the server address and password, then try again.",
  "server.connect.pair.description": "Run this command on your computer to get your connection details.",
  "server.connect.scan": "Scan QR code",
  "server.connect.scan.description": "Point your camera at the QR code shown by opencode pair.",
  "server.connect.scan.invalid": "This is not an OMM pairing code. Scan the code shown by opencode pair.",
  "server.connect.camera": "Pairing camera",
  "server.connect.camera.starting": "Opening camera…",
  "server.connect.mixedContent":
    "Could not connect to this HTTP server from an HTTPS page. Use an HTTPS server address instead.",
  "server.connect.camera.insecure": "QR scanning requires opening this page over HTTPS or on localhost.",
  "server.connect.camera.unavailable":
    "No camera is available to this browser. Enter your connection details manually.",
  "server.connect.camera.error":
    "Could not open the camera. Allow camera access or enter your connection details manually.",
  "dialog.server.edit.title": "Edit server",
  "dialog.server.default.title": "Default server",
  "dialog.server.default.description":
    "Connect to this server on app launch instead of starting a local server. Requires restart.",
  "dialog.server.default.none": "No server selected",
  "dialog.server.default.set": "Set current server as default",
  "dialog.server.default.clear": "Clear",
  "dialog.server.action.remove": "Remove server",

  "dialog.server.menu.edit": "Edit",
  "dialog.server.menu.default": "Set as default",
  "dialog.server.menu.defaultRemove": "Remove default",
  "dialog.server.menu.delete": "Delete",
  "dialog.server.menu.remove": "Remove",
  "dialog.server.menu.hide": "Hide from project list",
  "dialog.server.menu.show": "Show in project list",
  "dialog.server.current": "Current Server",
  "dialog.server.status.default": "Default",
  "wsl.server.add": "Add WSL server",
  "wsl.server.addShort": "Add WSL",
  "wsl.server.label": "WSL",
  "wsl.server.menu.label": "WSL server",
  "wsl.server.retryStart": "Retry start",
  "wsl.server.updating": "Updating…",
  "wsl.onboarding.step.distro": "Choose distro",
  "wsl.onboarding.step.opencode": "OMM",
  "wsl.onboarding.checkingRuntime": "Checking WSL…",
  "wsl.onboarding.restartRequired": "Windows needs a restart to finish installing WSL.",
  "wsl.onboarding.ready": "WSL is ready.",
  "wsl.onboarding.required": "WSL is required to continue.",
  "wsl.onboarding.checkingDistros": "Checking distros…",
  "wsl.onboarding.installingDistro": "Installing {{distro}}…",
  "wsl.onboarding.checkingDistro": "Checking {{distro}}…",
  "wsl.onboarding.listingDistros": "Listing distros…",
  "wsl.onboarding.distroReady": "{{distro}} is ready.",
  "wsl.onboarding.distroNotInstalled": "{{distro}} is not installed yet.",
  "wsl.onboarding.openDistroOnce": "Open {{distro}} once to finish setup.",
  "wsl.onboarding.finishingDistro": "Finishing setup for {{distro}}.",
  "wsl.onboarding.pickDistro": "Pick a distro or install one below.",
  "wsl.onboarding.checkingOpencode": "Checking OMM…",
  "wsl.onboarding.checkingOpencodeIn": "Checking OMM in {{distro}}…",
  "wsl.onboarding.updatingOpencode": "Updating OMM…",
  "wsl.onboarding.updatingOpencodeIn": "Updating OMM in {{distro}}…",
  "wsl.onboarding.updateOpencodeIn": "Update OMM in {{distro}}.",
  "wsl.onboarding.updateOpencode": "Update OMM",
  "wsl.onboarding.opencodeReadyIn": "OMM is ready in {{distro}}.",
  "wsl.onboarding.opencodeReady": "OMM is ready.",
  "wsl.onboarding.installOpencodeIn": "Install OMM in {{distro}}.",
  "wsl.onboarding.installOpencode": "Install OMM",
  "wsl.onboarding.chooseDistroFirst": "Choose a distro first.",
  "wsl.onboarding.loadFailed": "Failed to load WSL state.",
  "wsl.onboarding.loading": "Loading…",
  "wsl.onboarding.installedDistros": "Installed distros",
  "wsl.onboarding.checkAgain": "Check again",
  "wsl.onboarding.distroStatus.ready": "Ready",
  "wsl.onboarding.distroStatus.checking": "Checking…",
  "wsl.onboarding.distroStatus.opencodeMissing": "OMM not installed",
  "wsl.onboarding.distroStatus.missingTools": "Missing bash, curl",
  "wsl.onboarding.distroStatus.unsupported": "Unsupported · Use WSL 2",
  "wsl.onboarding.needAnotherDistro": "Need another distro?",
  "wsl.onboarding.needAnotherDistroHint": "Install a Linux distribution from the WSL catalog",
  "wsl.onboarding.wslNotInstalled.title": "WSL not installed",
  "wsl.onboarding.wslNotInstalled.description":
    "WSL (Windows Subsystem for Linux) is required before OMM can add a WSL server",
  "wsl.onboarding.wslUnavailable.title": "WSL unavailable",
  "wsl.onboarding.wslUnavailable.description": "OMM could not verify WSL on this machine.",
  "wsl.onboarding.installWsl": "Install WSL",
  "wsl.onboarding.windowsRestartRequired": "Restart Windows to finish installing WSL, then reopen OMM.",
  "wsl.onboarding.next": "Next",
  "wsl.onboarding.refresh": "Refresh",
  "wsl.onboarding.allDistrosAdded": "All installed distros are already added.",
  "wsl.onboarding.noDistros": "No distros detected yet.",
  "wsl.onboarding.install": "Install",
  "wsl.onboarding.installing": "Installing…",
  "wsl.onboarding.installDistro": "Install distro",
  "wsl.onboarding.searchDistros": "Search distros",
  "wsl.onboarding.wsl2Required": "WSL 2 is required.",
  "wsl.onboarding.toolsRequired": "This distro needs bash and curl.",
  "wsl.onboarding.openTerminal": "Open terminal",
  "wsl.onboarding.path": "Path: {{path}}",
  "wsl.onboarding.notFound": "not found",
  "wsl.onboarding.version": "Version: {{version}}",
  "wsl.onboarding.unknown": "unknown",
  "wsl.onboarding.desktopVersion": "desktop {{version}}",
  "wsl.onboarding.versionMismatch": "Installed version does not match the desktop app version.",
  "wsl.onboarding.adding": "Adding…",

  "server.row.incompatible":
    "This server is running OMM {{version}}, which isn't compatible with this app. Upgrade it to OMM V2 to continue.",

  "dialog.project.edit.title": "Edit project",
  "dialog.project.edit.name": "Name",
  "dialog.project.edit.icon": "Icon",
  "dialog.project.edit.icon.alt": "Project icon",
  "dialog.project.edit.icon.hint": "Click or drag an image",
  "dialog.project.edit.icon.recommended": "Recommended: 128x128px",
  "dialog.project.edit.color": "Color",
  "dialog.project.edit.color.select": "Select {{color}} color",
  "dialog.project.edit.worktree.startup": "Worktree startup script",
  "dialog.project.edit.worktree.startup.description":
    "Runs after creating a new worktree. Use $OPENCODE_WORKTREE_BASE for the base worktree and $OPENCODE_WORKTREE_PATH for the new worktree.",
  "dialog.project.edit.worktree.startup.placeholder": "e.g. bun install",
  "dialog.releaseNotes.action.getStarted": "Get started",
  "dialog.releaseNotes.action.next": "Next",
  "dialog.releaseNotes.action.hideFuture": "Don't show these in the future",
  "dialog.releaseNotes.media.alt": "Release preview",
  "dialog.usageExceeded.dontShowAgain": "Don't show again",

  "context.breakdown.title": "Context Breakdown",
  "context.breakdown.note": 'Approximate breakdown of input tokens. "Other" includes tool definitions and overhead.',
  "context.breakdown.system": "System",
  "context.breakdown.user": "User",
  "context.breakdown.assistant": "Assistant",
  "context.breakdown.tool": "Tool Calls",
  "context.breakdown.other": "Other",

  "context.systemPrompt.title": "System Prompt",
  "context.rawMessages.title": "Raw messages",
  "context.export.session": "Export exploration",

  "context.stats.session": "Exploration",
  "context.stats.messages": "Messages",
  "context.stats.provider": "Provider",
  "context.stats.model": "Model",
  "context.stats.limit": "Context Limit",
  "context.stats.totalTokens": "Total Tokens",
  "context.stats.usage": "Usage",
  "context.stats.inputTokens": "Input Tokens",
  "context.stats.outputTokens": "Output Tokens",
  "context.stats.reasoningTokens": "Reasoning Tokens",
  "context.stats.cacheTokens": "Cache Tokens (read/write)",
  "context.stats.userMessages": "User Messages",
  "context.stats.assistantMessages": "Assistant Messages",
  "context.stats.totalCost": "Total Cost",
  "context.stats.totalCredits": "Total Credits",
  "context.stats.sessionCreated": "Exploration Created",
  "context.stats.lastActivity": "Last Activity",

  "context.usage.tokens": "Tokens",
  "context.usage.usage": "Context",
  "context.usage.cost": "Cost",
  "context.usage.credits": "Credits",
  "context.usage.clickToView": "Click to view context",
  "context.usage.view": "View context usage",

  "language.en": "English",
  "language.zh": "简体中文",
  "language.zht": "繁體中文",
  "language.ko": "한국어",
  "language.de": "Deutsch",
  "language.es": "Español",
  "language.fr": "Français",
  "language.da": "Dansk",
  "language.ja": "日本語",
  "language.pl": "Polski",
  "language.ru": "Русский",
  "language.ar": "العربية",
  "language.no": "Norsk",
  "language.br": "Português (Brasil)",
  "language.bs": "Bosanski",
  "language.uk": "Українська",
  "language.th": "ไทย",
  "language.tr": "Türkçe",

  "toast.language.title": "Language",
  "toast.language.description": "Switched to {{language}}",

  "toast.theme.title": "Theme switched",
  "toast.scheme.title": "Color scheme",

  "toast.workspace.enabled.title": "Worktrees enabled",
  "toast.workspace.enabled.description": "Multiple worktrees are now shown in the sidebar",
  "toast.workspace.disabled.title": "Worktrees disabled",
  "toast.workspace.disabled.description": "Only the main worktree is shown in the sidebar",

  "toast.permissions.autoaccept.on.title": "Auto-accepting permissions",
  "toast.permissions.autoaccept.on.description": "Permission requests will be automatically approved",
  "toast.permissions.autoaccept.off.title": "Stopped auto-accepting permissions",
  "toast.permissions.autoaccept.off.description": "Permission requests will require approval",

  "toast.model.none.title": "No model selected",
  "toast.model.none.description": "Connect a provider to summarize this exploration",

  "toast.file.loadFailed.title": "Failed to load file",
  "file.error.notFound": "File not found: {{name}}",
  "toast.file.listFailed.title": "Failed to list files",
  "file.view.preview": "Preview",
  "file.view.source": "Source",
  "file.view.openInBrowser": "Open in browser",
  "file.view.binary": "Binary file · {{size}}",
  "file.view.table.rows.one": "{{count}} row",
  "file.view.table.rows.other": "{{count}} rows",
  "file.view.table.columns.one": "{{count}} column",
  "file.view.table.columns.other": "{{count}} columns",
  "file.view.table.truncated": "Showing the first {{shown}} of {{total}} rows.",
  "file.view.fontSample": "Sphinx of black quartz, judge my vow.",

  "toast.context.noLineSelection.title": "No line selection",
  "toast.context.noLineSelection.description": "Select a line range in a file tab first.",

  "toast.session.unshare.success.title": "Exploration unshared",
  "toast.session.unshare.success.description": "Exploration unshared successfully!",
  "toast.session.unshare.failed.title": "Failed to unshare exploration",
  "toast.session.unshare.failed.description": "An error occurred while unsharing the exploration",

  "toast.session.export.success.title": "Exploration exported",
  "toast.session.export.success.description": "Saved exploration to {{filename}}",
  "toast.session.export.failed.title": "Failed to export exploration",
  "toast.session.export.failed.description": "An error occurred while exporting the exploration",
  "toast.session.copyID.failed.title": "Failed to copy exploration ID",
  "toast.session.copyID.failed.description": "An error occurred while copying the exploration ID",
  "toast.project.copyID.failed.title": "Failed to copy project ID",
  "toast.project.copyID.failed.description": "An error occurred while copying the project ID",

  "toast.session.listFailed.title": "Failed to load explorations for {{project}}",
  "toast.project.reloadFailed.title": "Failed to reload {{project}}",
  "toast.migration.failed.title": "Data migration failed",

  "toast.update.title": "Update available",
  "toast.update.description": "A new version of OMM ({{version}}) is now available to install.",
  "toast.update.action.installRestart": "Install and restart",
  "toast.update.action.notYet": "Not yet",

  "error.page.title": "Something went wrong",
  "error.page.title.status": "Server request failed",
  "error.page.description": "An error occurred while loading the application.",
  "error.page.description.status": "The server returned an HTTP {{status}} response.",
  "error.page.description.localServerStartup": "An error occurred while starting the local server.",
  "error.page.details.label": "Error Details",
  "error.page.action.restart": "Restart",
  "error.page.action.reload": "Reload",
  "error.page.action.report": "Report Error",
  "error.page.action.reported": "Error Reported",
  "error.page.action.exportLogs": "Export Logs",
  "error.page.action.checking": "Checking…",
  "error.page.action.checkUpdates": "Check for updates",
  "error.page.action.updateTo": "Update to {{version}}",
  "error.page.circular": "[Circular]",
  "error.page.report.prefix": "Please report this error to the OMM team",
  "error.page.report.discord": "on Discord",
  "error.page.report.zulip": "on Zulip",
  "error.page.version": "Version: {{version}}",

  "error.dev.rootNotFound":
    "Root element not found. Did you forget to add it to your index.html? Or maybe the id attribute got misspelled?",

  "error.serverSync.connectFailed": "Could not connect to server. Is there a server running at `{{url}}`?",
  "error.serverSDK.noServerAvailable": "No server available",
  "error.serverSDK.serverNotAvailable": "Server not available",
  "error.childStore.persistedCacheCreateFailed": "Failed to create persisted cache",
  "error.childStore.persistedProjectMetadataCreateFailed": "Failed to create persisted project metadata",
  "error.childStore.persistedProjectIconCreateFailed": "Failed to create persisted project icon",
  "error.childStore.storeCreateFailed": "Failed to create store",
  "directory.error.invalidUrl": "Invalid directory in URL.",

  "error.chain.unknown": "Unknown error",
  "error.server.invalidConfiguration": "Invalid configuration",
  "error.chain.causedBy": "Caused by:",
  "error.chain.apiError": "API error",
  "error.chain.status": "Status: {{status}}",
  "error.chain.retryable": "Retryable: {{retryable}}",
  "error.chain.responseBody": "Response body:\n{{body}}",
  "error.chain.didYouMean": "Did you mean: {{suggestions}}",
  "error.chain.modelNotFound": "Model not found: {{provider}}/{{model}}",
  "error.chain.checkConfig": "Check your config (opencode.json) provider/model names",
  "error.chain.mcpFailed": 'MCP server "{{name}}" failed. Note, OMM does not support MCP authentication yet.',
  "error.chain.providerAuthFailed": "Provider authentication failed ({{provider}}): {{message}}",
  "error.chain.providerInitFailed":
    'Failed to initialize provider "{{provider}}". Check credentials and configuration.',
  "error.chain.configJsonInvalid": "Config file at {{path}} is not valid JSON(C)",
  "error.chain.configJsonInvalidWithMessage": "Config file at {{path}} is not valid JSON(C): {{message}}",
  "error.chain.configDirectoryTypo":
    'Directory "{{dir}}" in {{path}} is not valid. Rename the directory to "{{suggestion}}" or remove it. This is a common typo.',
  "error.chain.configFrontmatterError": "Failed to parse frontmatter in {{path}}:\n{{message}}",
  "error.chain.configInvalid": "Config file at {{path}} is invalid",
  "error.chain.configInvalidWithMessage": "Config file at {{path}} is invalid: {{message}}",

  "notification.permission.title": "Permission required",
  "notification.permission.description": "{{sessionTitle}} in {{projectName}} needs permission",
  "notification.question.title": "Question",
  "notification.question.description": "{{sessionTitle}} in {{projectName}} has a question",
  "notification.action.goToSession": "Go to exploration",

  "notification.session.responseReady.title": "Response ready",
  "notification.session.error.title": "Exploration error",
  "notification.session.error.fallbackDescription": "An error occurred",

  "home.recentProjects": "Recent projects",
  "home.empty.title": "No recent projects",
  "home.empty.description": "Get started by opening a local project",
  "home.title": "Home",
  "home.projects": "Projects",
  "home.projects.all": "All projects",
  "home.project.add": "Add project",
  "home.recentlyClosed": "Recently closed",
  "home.server.collapse": "Collapse server projects",
  "home.server.expand": "Expand server projects",
  "home.sessions.search.placeholder": "Search explorations",
  "home.sessions.search.placeholder.scoped": "Search explorations in {{scope}}",
  "home.sessions.search.sessions": "Explorations",
  "home.sessions.search.noResults": "No explorations found for {{query}}",
  "home.sessions.empty": "Nothing here yet",
  "home.sessions.empty.description": "Create an exploration to get started",
  "home.sessions.group.today": "Today",
  "home.sessions.group.yesterday": "Yesterday",
  "home.sessions.group.older": "Older",
  "home.providerTip": "Connect to 75+ providers to use other models, including Claude, GPT, Gemini, etc",
  "home.workspaceTip": "Start next exploration in a new workspace to keep changes isolated",

  "session.tab.session": "Exploration",
  "session.tab.files": "Files",
  "session.files.openTabs": "Open files",
  "session.files.actions": "File actions",
  "session.files.search": "Search files",
  "session.files.closeSearch": "Close file search",
  "session.files.refresh": "Refresh files",
  "session.files.retry": "Retry",
  "session.files.transferAndCreate": "Upload, download, or create",
  "session.tab.usage": "Usage",
  "session.view.select": "Exploration view",
  "session.tab.review": "Review",
  "session.tab.browser": "Browser",
  "session.tab.add": "Add tab",
  "session.tab.context": "Context",
  "session.tab.unknown": "Unknown Exploration",
  "session.panel.reviewAndFiles": "Review and files",
  "session.error.notFound": "This exploration cannot be found",
  "session.error.notFound.description": "This tab points to an exploration that no longer exists on this server.",
  "session.error.notFound.closeTab": "Close Tab",
  "session.error.incompatible": "This server version isn't supported",
  "session.error.incompatible.description":
    "{{server}} is running OMM {{version}}, which isn't compatible with this app. Upgrade the server to OMM V2 to continue.",
  "session.background.moveTasks": "Move {{tasks}} to background",
  "session.background.moveRunning": "Move to background",
  "session.background.inBackground": "Running {{tasks}} in background",
  "session.background.moveInline": "Press {{keybind}} to move running work to the background",
  "session.background.running": "Running work in background",
  "session.background.runningCount.one": "{{count}} item running in background",
  "session.background.runningCount.other": "{{count}} items running in background",
  "session.background.tasksRunning.one": "{{count}} background task running",
  "session.background.tasksRunning.other": "{{count}} background tasks running",
  "session.background.combine": "{{first}} and {{second}}",
  "session.background.shell.one": "{{count}} shell",
  "session.background.shell.other": "{{count}} shells",
  "session.background.subagent.one": "{{count}} subagent",
  "session.background.subagent.other": "{{count}} subagents",
  "command.session.background": "Move to background",
  "session.queue.count.one": "{{count}} queued",
  "session.queue.count.other": "{{count}} queued",
  "session.queue.steer": "Steer",
  "session.queue.queuedCount.one": "Queued · {{count}}",
  "session.queue.queuedCount.other": "Queued · {{count}}",
  "session.queue.sendNow": "Send now",
  "session.queue.sendNowTooltip": "Send to the running task at its next step.",
  "session.queue.edit": "Edit",
  "session.queue.editTooltip": "Move back to the input to edit.",
  "session.queue.withdrawFailed": "Couldn't move this message back to the input",
  "session.queue.alreadyDelivered": "This message has already started and can't be moved back to the input.",
  "session.queue.restoreDraft": "Restore previous draft",
  "session.queue.withdrawUnknown": "Couldn't confirm whether this message was withdrawn. Check again before sending.",
  "session.queue.checkWithdrawal": "Check again",
  "session.execution.stopping": "Stopping…",
  "session.execution.continuing": "Continuing…",
  "session.execution.stopped": "Stopped",
  "session.execution.continue": "Continue",
  "session.execution.stopFailed": "Couldn't stop the task",
  "session.execution.continueFailed": "Couldn't continue the task",
  "session.queue.send": "Send",
  "session.queue.steerTooltip": "Send without interrupting",
  "session.queue.remove": "Remove",
  "session.queue.reorder": "Reorder queued prompt",
  "session.queue.attachments.one": "{{count}} attachment",
  "session.queue.attachments.other": "{{count}} attachments",
  "session.timeline.working": "Working",
  "session.timeline.notice.finished": "{{actor}} finished",
  "session.timeline.notice.failed": "{{actor}} failed",
  "session.timeline.notice.cancelled": "{{actor}} cancelled",
  "session.error.serverConnection": "Can't connect to this server",
  "session.review.filesChanged": "Files Changed {{count}}",
  "session.review.change.one": "Change",
  "session.review.change.other": "Changes",
  "session.review.loadingChanges": "Loading changes…",
  "session.review.wrapLines": "Wrap lines",
  "session.review.empty": "No changes in this exploration yet",
  "session.review.noVcs": "No Git Version Control System detected, changes not displayed",
  "session.review.noVcs.createGit.title": "Create a Git repository",
  "session.review.noVcs.createGit.description": "Track, review, and undo changes in this project",
  "session.review.noVcs.createGit.actionLoading": "Creating Git repository…",
  "session.review.noVcs.createGit.action": "Create Git repository",
  "session.review.noSnapshot": "Snapshot tracking is disabled in config, so exploration changes are unavailable",
  "session.review.noChanges": "No changes",
  "session.review.noUncommittedChanges": "No uncommitted changes yet",
  "session.review.noBranchChanges": "No branch changes yet",

  "session.files.selectToOpen": "Select a file to open",
  "session.files.all": "All files",
  "session.files.empty": "No files",
  "session.files.emptyFolder": "This folder is empty",
  "session.files.emptyDirectory": "Empty",
  "session.files.dropToUpload": "Drop files here to add them to this project, or choose files to upload.",
  "session.files.dropIntoProject": "Drop to upload into this project",
  "session.files.dropIntoFolder": "Drop to upload into {{name}}",
  "session.files.binaryContent": "Binary file (content cannot be displayed)",

  "session.messages.renderEarlier": "Render earlier messages",
  "session.messages.loadingEarlier": "Loading earlier messages…",
  "session.messages.loadEarlier": "Load earlier messages",
  "session.messages.loading": "Loading messages…",
  "session.messages.jumpToLatest": "Jump to latest",

  "session.context.addToContext": "Add {{selection}} to context",
  "session.todo.title": "Todos",
  "session.todo.collapse": "Collapse",
  "session.todo.expand": "Expand",
  "session.todo.progress": "{{done}} of {{total}} todos completed",
  "session.question.progress": "{{current}} of {{total}} questions",
  "session.websearch.title": "Third-party web search",
  "session.websearch.description": "Select the search provider agents use to search the web",
  "session.websearch.provider": "Search provider",
  "session.websearch.any": "Any",
  "session.websearch.disable": "Don’t use search",
  "session.websearch.enable": "Enable",
  "session.websearch.loadFailed": "Could not load search providers.",
  "session.websearch.empty": "No search providers available.",
  "session.websearch.failed": "Could not save your choice. Please try again.",
  "session.websearch.retry": "Retry",
  "session.question.minimize": "Minimize question",
  "session.question.restore": "Restore question",
  "session.question.pending.one": "{{count}} pending question",
  "session.question.pending.other": "{{count}} pending questions",

  "session.new.failed": "Couldn’t open a new exploration",
  "session.new.title": "Start with a mathematical question",
  "session.new.examples.title": "Example problems",
  "session.new.examples.hint": "Click to add the full problem to your draft",
  "session.new.examples.showMore": "Show more problems",
  "session.new.examples.showLess": "Show fewer problems",
  "session.new.examples.imc2025p1.label": "IMC 2025 P1",
  "session.new.examples.imc2025p1.question": "Can polynomial tangent lines cover the whole plane?",
  "session.new.examples.imc2025p1.prompt":
    "IMC 2025 Problem 1. Let P be a real polynomial of degree at least 2. For each real x, let L_x be the tangent line to the graph of P at (x,P(x)). Prove that the union of all L_x is the whole plane if the degree of P is odd. Can a polynomial of even degree also have this property?",
  "session.new.examples.putnam1971a6.label": "Putnam 1971 A6",
  "session.new.examples.putnam1971a6.question": "If every n^c is an integer, what can c be?",
  "session.new.examples.putnam1971a6.prompt":
    "Putnam 1971 A6. Let c be real. Suppose n^c is an integer for every positive integer n. Prove that c must be a nonnegative integer.",
  "session.new.examples.imo2023p5.label": "IMO 2023 P5",
  "session.new.examples.imo2023p5.question": "How many red circles can a downward path always visit?",
  "session.new.examples.imo2023p5.prompt":
    "IMO 2023 Problem 5. Arrange 1+2+⋯+n circles in a triangle with i circles in row i, for i=1,…,n. Exactly one circle in each row is red. A path starts at the top and moves from each circle to one of the two circles directly below it until it reaches the bottom row. Find the largest k, as a function of n, such that every possible red coloring has a path visiting at least k red circles.",
  "session.new.examples.imc2025p3.label": "IMC 2025 P3",
  "session.new.examples.imc2025p3.question": "How often do two random rank-one matrices commute?",
  "session.new.examples.imc2025p3.prompt":
    "IMC 2025 Problem 3. Let S be the set of real symmetric 2025×2025 matrices of rank one whose entries are all +1 or −1. Choose A and B independently and uniformly from S. Find the probability that AB=BA.",
  "session.new.examples.putnam1988a5.label": "Putnam 1988 A5",
  "session.new.examples.putnam1988a5.question": "Does f(f(x))=6x−f(x) uniquely determine f?",
  "session.new.examples.putnam1988a5.prompt":
    "Putnam 1988 A5. Find and prove the uniqueness of a function f:(0,∞)→(0,∞) satisfying f(f(x))=6x−f(x) for every x>0. Do not assume continuity.",
  "session.new.examples.imc2024p3.label": "IMC 2024 P3",
  "session.new.examples.imc2024p3.question": "When can a 0–1 matrix square to the all-ones matrix?",
  "session.new.examples.imc2024p3.prompt":
    "IMC 2024 Problem 3. Determine all positive integers n for which there is an n×n matrix A with every entry either 0 or 1 and A² equal to the n×n all-ones matrix.",
  "session.new.examples.imo2023p1.label": "IMO 2023 P1",
  "session.new.examples.imo2023p1.question": "Which composite numbers satisfy a divisor-sum condition?",
  "session.new.examples.imo2023p1.prompt":
    "IMO 2023 Problem 1. List the positive divisors of a composite integer n>1 as 1=d₁<d₂<⋯<dₖ=n. Find every such n for which dᵢ divides dᵢ₊₁+dᵢ₊₂ for each i from 1 to k−2.",
  "session.new.examples.imc2025p2.label": "IMC 2025 P2",
  "session.new.examples.imc2025p2.question": "What is the sharp lower bound for a second-derivative integral?",
  "session.new.examples.imc2025p2.prompt":
    "IMC 2025 Problem 2. Let f:ℝ→ℝ be twice continuously differentiable, with ∫₋₁¹ f(x) dx=0 and f(−1)=f(1)=1. Prove that ∫₋₁¹ (f''(x))² dx≥15, and determine all functions for which equality holds.",
  "session.new.examples.putnam1988a6.label": "Putnam 1988 A6",
  "session.new.examples.putnam1988a6.question": "Do n+1 eigenvectors force a linear map to be scalar?",
  "session.new.examples.putnam1988a6.prompt":
    "Putnam 1988 A6. Let V be an n-dimensional vector space and A:V→V a linear operator. Suppose A has n+1 eigenvectors such that every choice of n is linearly independent. Must A be a scalar multiple of the identity? Prove your conclusion.",
  "session.new.examples.imc2024p6.label": "IMC 2024 P6",
  "session.new.examples.imc2024p6.question": "Must every integer-valued function on ℚ have a local peak?",
  "session.new.examples.imc2024p6.prompt":
    "IMC 2024 Problem 6. Given any function f:ℚ→ℤ, prove that there are rational numbers a<b<c such that f(b)≥f(a) and f(b)≥f(c). No continuity or boundedness assumption is allowed.",
  "session.new.examples.putnam1997a5.label": "Putnam 1997 A5",
  "session.new.examples.putnam1997a5.question": "Is the number of reciprocal-sum 10-tuples odd or even?",
  "session.new.examples.putnam1997a5.prompt":
    "Putnam 1997 A5. For each positive integer n, let Nₙ count the ordered n-tuples (a₁,…,aₙ) of positive integers for which 1/a₁+⋯+1/aₙ=1. Determine whether N₁₀ is odd or even, and prove your answer.",
  "session.new.examples.imc2025p7.label": "IMC 2025 P7",
  "session.new.examples.imc2025p7.question": "Which sets of positive integers are closed under doubling and midpoints?",
  "session.new.examples.imc2025p7.prompt":
    "IMC 2025 Problem 7. Determine all nonempty sets M of positive integers with both properties: if x belongs to M, then 2x belongs to M; and if x,y belong to M with x+y even, then (x+y)/2 belongs to M.",
  "session.new.project.new": "New project",
  "session.new.project.openExisting": "Open existing project",
  "session.new.project.search": "Search projects",
  "session.new.project.add": "Add project",
  "session.new.project.location": "{{project}} on {{server}}",
  "session.new.worktree.main": "Main branch",
  "session.new.worktree.mainWithBranch": "Main branch ({{branch}})",
  "session.new.worktree.create": "Create new worktree",
  "session.new.worktree.creating": "Creating worktree",
  "session.new.worktree.draftPlaceholder": "Draft a follow-up while the worktree is being prepared…",
  "session.new.workspace.runIn": "Run exploration in",
  "session.new.workspace.triggerLocal": "Local",
  "session.new.workspace.local": "Local repository",
  "session.new.workspace.existing": "Worktree…",
  "session.new.git.none": "No Git",
  "session.new.lastModified": "Last modified",

  "session.header.search.placeholder": "Search {{project}}",
  "session.header.searchFiles": "Search files",
  "session.search.placeholder": "Find...",
  "session.search.noResults": "No matches",
  "session.header.openIn": "Open in",
  "session.header.open.action": "Open {{app}}",
  "session.header.open.ariaLabel": "Open in {{app}}",
  "session.header.open.menu": "Open options",
  "session.header.open.copyPath": "Copy path",
  "session.header.open.finder": "Finder",
  "session.header.open.fileExplorer": "File Explorer",
  "session.header.open.fileManager": "File Manager",
  "session.header.reveal.finder": "Reveal in Finder",
  "session.header.reveal.fileExplorer": "Reveal in File Explorer",
  "session.header.reveal.containingFolder": "Open containing folder",
  "session.header.open.app.vscode": "VS Code",
  "session.header.open.app.cursor": "Cursor",
  "session.header.open.app.zed": "Zed",
  "session.header.open.app.textmate": "TextMate",
  "session.header.open.app.antigravity": "Antigravity",
  "session.header.open.app.terminal": "Terminal",
  "session.header.open.app.iterm2": "iTerm2",
  "session.header.open.app.ghostty": "Ghostty",
  "session.header.open.app.warp": "Warp",
  "session.header.open.app.xcode": "Xcode",
  "session.header.open.app.androidStudio": "Android Studio",
  "session.header.open.app.powershell": "PowerShell",
  "session.header.open.app.sublimeText": "Sublime Text",

  "status.popover.trigger": "Status",
  "status.popover.ariaLabel": "Server configurations",
  "status.popover.tab.servers": "Servers",
  "status.popover.tab.mcp": "MCP",
  "status.popover.tab.lsp": "LSP",
  "status.popover.tab.plugins": "Plugins",
  "status.popover.action.manageServers": "Manage servers",

  "common.copied": "Copied",

  "lsp.tooltip.none": "No LSP servers",
  "lsp.label.connected": "{{count}} LSP",

  "prompt.loading": "Loading prompt…",
  "terminal.loading": "Loading terminal…",
  "terminal.title": "Terminal",
  "terminal.title.numbered": "Terminal {{number}}",
  "terminal.close": "Close terminal",
  "terminal.connectionLost.title": "Connection Lost",
  "terminal.connectionLost.abnormalClose": "WebSocket closed abnormally: {{code}}",
  "terminal.connectionLost.description":
    "The terminal connection was interrupted. This can happen when the server restarts.",
  "terminal.connectTicket.csrfError":
    "PTY connect ticket rejected by origin or CSRF checks. Check the server CORS config.",
  "terminal.connectTicket.statusError": "PTY connect ticket failed with {{status}}",

  "session.browser.address": "Browser address",
  "session.browser.replaced": "Browser control moved to another desktop window.",
  "session.browser.suspended": "Browser suspended. Interact with this exploration to reconnect.",
  "session.browser.address.placeholder": "Enter URL",
  "session.browser.empty.title": "Enter URL",
  "session.browser.empty.description": 'Or prompt "Open in the app browser"',
  "session.browser.failed.title": "URL can't be reached",
  "session.browser.failed.description": "Check the URL and your connection, then try again.",

  "titlebar.update": "Update",
  "titlebar.tabs": "Tabs",
  "titlebar.channel.local": "Local",
  "titlebar.channel.dev": "Dev",
  "titlebar.channel.beta": "Beta",
  "titlebar.toggleDebugTools": "Toggle debug tools",
  "titlebar.updateVersion": "Update {{version}}",

  "common.closeTab": "Close tab",
  "common.dismiss": "Dismiss",
  "common.moreCountSuffix": " (+{{count}} more)",
  "common.requestFailed": "Request failed",
  "common.moreOptions": "More options",
  "common.learnMore": "Learn more",
  "common.rename": "Rename",
  "common.export": "Export",
  "common.reset": "Reset",
  "common.archive": "Archive",
  "common.delete": "Delete",
  "common.close": "Close",
  "common.edit": "Edit",
  "common.loadMore": "Load more",
  "common.key.esc": "ESC",
  "common.key.ctrl": "Ctrl",
  "common.key.alt": "Alt",
  "common.key.shift": "Shift",
  "common.key.meta": "Meta",
  "common.key.space": "Space",
  "common.key.backspace": "Backspace",
  "common.key.enter": "Enter",
  "common.key.tab": "Tab",
  "common.key.delete": "Delete",
  "common.key.home": "Home",
  "common.key.end": "End",
  "common.key.pageUp": "Page Up",
  "common.key.pageDown": "Page Down",
  "common.key.insert": "Insert",
  "common.unknown": "unknown",

  "common.time.justNow": "Just now",
  "common.time.minutesAgo.short": "{{count}}m ago",
  "common.time.hoursAgo.short": "{{count}}h ago",
  "common.time.daysAgo.short": "{{count}}d ago",

  "sidebar.menu.toggle": "Toggle menu",
  "sidebar.nav.projectsAndSessions": "Projects and explorations",
  "sidebar.settings": "Settings",
  "sidebar.help": "Help",
  "sidebar.workspaces.enable": "Enable worktrees",
  "sidebar.workspaces.disable": "Disable worktrees",
  "sidebar.gettingStarted.title": "Getting started",
  "sidebar.gettingStarted.line1": "Sign in to SAIR to use available models in OMM.",
  "sidebar.gettingStarted.line2": "Connect any provider to use models, inc. Claude, GPT, Gemini etc.",
  "sidebar.project.recentSessions": "Recent explorations",
  "sidebar.project.viewAllSessions": "View all explorations",
  "sidebar.project.clearNotifications": "Clear notifications",
  "sidebar.empty.title": "No projects open",
  "sidebar.empty.description": "Open a project to get started",

  "debugBar.ariaLabel": "Development performance diagnostics",
  "debugBar.providerAriaLabel": "Provider performance diagnostics",
  "debugBar.na": "n/a",
  "debugBar.ttft.label": "TTFT",
  "debugBar.ttft.tip": "Time from provider request dispatch to the first model output.",
  "debugBar.ttfa.label": "TTFA",
  "debugBar.ttfa.tip": "Time from provider request dispatch to the first answer text.",
  "debugBar.tps.label": "TPS",
  "debugBar.tps.tip": "Output tokens per second after the first model output.",
  "debugBar.e2e.label": "E2E",
  "debugBar.e2e.tip": "Time from provider request dispatch until its response stream ended.",
  "debugBar.nav.label": "NAV",
  "debugBar.nav.tip":
    "Last completed route transition touching an exploration page, measured from router start until the first paint after it settles.",
  "debugBar.fps.label": "FPS",
  "debugBar.fps.tip": "Rolling frames per second over the last 5 seconds.",
  "debugBar.frame.label": "FRAME",
  "debugBar.frame.tip": "Worst frame time over the last 5 seconds.",
  "debugBar.jank.label": "JANK",
  "debugBar.jank.tip": "Frames over 32ms in the last 5 seconds.",
  "debugBar.long.label": "LONG",
  "debugBar.long.tip": "Blocked time and long-task count in the last 5 seconds. Max task: {{max}}.",
  "debugBar.delay.label": "DELAY",
  "debugBar.delay.tip": "Worst observed input delay in the last 5 seconds.",
  "debugBar.inp.label": "INP",
  "debugBar.inp.tip":
    "Approximate interaction duration over the last 5 seconds. This is INP-like, not the official Web Vitals INP.",
  "debugBar.cls.label": "CLS",
  "debugBar.cls.tip": "Cumulative layout shift for the current app lifetime.",
  "debugBar.mem.label": "MEM",
  "debugBar.mem.tipUnavailable": "Used JS heap vs heap limit. Chromium only.",
  "debugBar.mem.tip": "Used JS heap vs heap limit. {{used}} of {{limit}}.",
  "debugBar.focus.label": "FOCUS",
  "debugBar.focus.tip": "Force focus styles on all interactive elements",
  "debugBar.focus.on": "ON",
  "debugBar.focus.off": "OFF",
  "debugBar.direction.label": "DIR",
  "debugBar.direction.tip": "Force the full app layout direction without changing the selected language",
  "debugBar.direction.ltr": "LTR",
  "debugBar.direction.rtl": "RTL",

  "app.name.desktop": "OMM",

  "settings.section.desktop": "Desktop",
  "settings.section.server": "Server",
  "settings.backToApp": "Back to app",
  "settings.backToSettings": "Back to settings",
  "settings.backToProjects": "Back to projects",
  "settings.search.placeholder": "Search",
  "settings.search.results": "Settings results",
  "settings.search.group.pages": "Pages",
  "settings.search.group.settings": "Settings",
  "settings.search.group.projects": "Projects",
  "settings.search.group.servers": "Servers",
  "settings.search.result": "{{title}}, {{scope}}, {{page}}",
  "settings.search.page": "{{title}}, {{scope}}",
  "settings.search.result.unscoped": "{{title}}, {{page}}",
  "settings.search.empty": "No results for {{query}}",
  "settings.search.empty.query": '"{{query}}"',
  "settings.search.refine": "Narrow your search to see more specific results.",
  "settings.tab.general": "General",
  "settings.tab.preferences": "Preferences",
  "settings.tab.shortcuts": "Shortcuts",
  "settings.tab.notifications": "Notifications",
  "settings.tab.projects": "Projects",
  "settings.tab.extensions": "Extensions",
  "settings.tab.experimental": "Experimental",
  "settings.experimental.description": "Try experimental features",
  "settings.tab.about": "About",
  "settings.about.version": "Version {{version}}",
  "settings.about.devVersion": "development",
  "settings.about.license": "Released under the MIT License",
  "settings.about.website": "SAIR website",
  "settings.about.description": "SAIR is an AI coding application.",
  "settings.preferences.description": "Customize preferences and theme and default behavior",
  "settings.appearance.description": "Customize theme and fonts",
  "settings.appearance.section.experimental": "Experimental",
  "settings.appearance.row.tabs.title": "Tabs",
  "settings.appearance.row.tabs.description": "Choose how exploration tabs are arranged",
  "settings.appearance.row.tabs.horizontal": "Horizontal",
  "settings.appearance.row.tabs.vertical": "Vertical",
  "settings.appearance.row.projectName.title": "Show project names",
  "settings.appearance.row.projectName.description": "Show project names in vertical tabs and the mobile tab drawer",
  "settings.notifications.description": "Choose when to receive notifications and hear sounds",
  "settings.shortcuts.description": "Customize shortcuts for common actions",
  "settings.servers.description": "Manage server connections",
  "settings.server.description": "Manage this server’s connection and preferences",
  "settings.server.section.connection": "Connection",
  "settings.server.preferences.websearch.title": "Third-party search",
  "settings.server.preferences.websearch.description": "Select the search provider agents use to search the web",
  "settings.projects.title": "Projects",
  "settings.projects.description": "Manage project settings on this server",
  "settings.projects.empty": "No projects found",
  "settings.projects.search.placeholder": "Search projects",
  "settings.projects.server.all": "All servers",
  "settings.mcps.description": "Manage Model Context Protocol (MCP) servers and tools",
  "settings.extensions.description": "Manage extensions available on this server",
  "settings.extensions.tab.mcps": "MCPs",
  "settings.extensions.tab.skills": "Skills",
  "settings.extensions.availableAll": "Available to all projects",
  "settings.extensions.manageConfig": "Manage in opencode.json",
  "settings.extensions.addSkills": "How to add skills",
  "settings.desktop.section.wsl": "WSL",
  "settings.desktop.wsl.title": "WSL integration",
  "settings.desktop.wsl.description": "Run the OMM server inside WSL on Windows.",
  "dialog.server.authenticate.title": "Authenticate",
  "project.settings.title": "Edit project",
  "project.settings.general.description": "Manage project name and appearance",
  "project.settings.name.title": "Project name",
  "project.settings.name.description": "The name shown for this project throughout OMM",
  "project.settings.name.folderDescription": "Renaming also changes the project folder name on its computer.",
  "project.settings.icon.description": "Recommended: 128×128px. Click or drag to upload an image.",
  "project.settings.color.description": "Used for the project icon when no custom image is set",
  "project.settings.worktree.startup.description": "Runs once after creating a new worktree",
  "project.settings.worktree.startup.hint.base": "Use $OPENCODE_WORKTREE_BASE for the base worktree.",
  "project.settings.worktree.startup.hint.new": "Use $OPENCODE_WORKTREE_PATH for the new worktree.",
  "project.settings.scripts": "Scripts",
  "project.settings.scripts.description": "Configure scripts for this project",
  "project.settings.extensions.description": "View extensions available to this project",
  "project.settings.extensions.tab.lsps": "LSPs",
  "project.settings.extensions.added": "Added to this project",
  "project.settings.extensions.shared": "Shared with all projects",
  "project.settings.extensions.empty.mcps.title": "No MCPs yet",
  "project.settings.extensions.empty.mcps.description": "MCPs available to OMM will appear here",
  "project.settings.extensions.empty.plugins.title": "No plugins yet",
  "project.settings.extensions.empty.plugins.description": "Plugins available to OMM will appear here",
  "project.settings.extensions.empty.skills.title": "No skills yet",
  "project.settings.extensions.empty.skills.description": "Skills available to OMM will appear here",
  "project.settings.extensions.lsp.detected": "Detected language servers",
  "project.settings.extensions.lsp.description": "Auto-detected from file types",
  "project.settings.extensions.lsp.configured": "Configured language servers",
  "project.settings.extensions.lsp.status.enabled": "Enabled in config",
  "project.settings.extensions.lsp.status.disabled": "Disabled in config",
  "project.settings.extensions.lsp.empty.title": "No language servers configured",
  "project.settings.extensions.lsp.empty.description": "Language servers configured for this project will appear here",
  "project.settings.extensions.lsp.disabled.title": "Language servers disabled",
  "project.settings.extensions.lsp.disabled.description": "LSP is disabled in this project’s configuration",
  "project.settings.extensions.lsp.loadFailed": "Could not load language server configuration",
  "project.settings.extensions.lsp.retry": "Retry",
  "project.settings.extensions.setupRequired": "Setup required",

  "settings.general.section.appearance": "Appearance",
  "settings.general.section.general": "General",
  "settings.general.section.advanced": "Advanced",
  "settings.general.section.notifications": "Desktop notifications",
  "settings.general.section.updates": "Updates",
  "settings.general.section.sounds": "Sound effects",
  "settings.general.section.feed": "Feed",
  "settings.general.section.display": "Display",

  "settings.timeline.title": "Timeline",
  "settings.timeline.detail": "Timeline detail",
  "settings.timeline.description": "Choose how much detail appears in the exploration timeline.",
  "settings.timeline.summary": "{{preset}}:",
  "settings.timeline.preset.everything": "Everything",
  "settings.timeline.preset.detailed": "Detailed",
  "settings.timeline.preset.compact": "Compact",
  "settings.timeline.preset.quiet": "Quiet",
  "settings.timeline.preset.text-only": "Messages only",
  "settings.timeline.description.everything": "Show all activity separately. Expand shell output, edits, and thinking.",
  "settings.timeline.description.detailed":
    "Expand shell output and edits. Show subagents separately and group other activity.",
  "settings.timeline.description.compact": "Group all activity with details collapsed.",
  "settings.timeline.description.quiet": "Group edits and subagents. Hide other activity.",
  "settings.timeline.description.text-only": "Hide all activity.",
  "settings.timeline.description.custom": "Uses advanced settings.",
  "settings.timeline.custom": "Custom",
  "settings.timeline.advanced": "Advanced",
  "settings.timeline.advanced.description": "Set placement and details for each activity category.",
  "settings.timeline.group": "Group",
  "settings.timeline.collapse": "Collapse",
  "settings.timeline.visibility.show": "Show",
  "settings.timeline.visibility.hide": "Hide",
  "settings.timeline.visibility.label": "{{activity}} visibility",
  "settings.timeline.grouped.label": "{{activity}} grouped",
  "settings.timeline.collapsed.label": "{{activity}} collapsed",
  "settings.timeline.category.shell": "Shell",
  "settings.timeline.category.edit": "Edits",
  "settings.timeline.category.thinking": "Thinking",
  "settings.timeline.category.subagents": "Subagents",
  "settings.timeline.category.notices": "Notices",
  "settings.timeline.category.tools": "Other tools",

  "settings.general.row.language.title": "Language",
  "settings.general.row.language.description": "Change the display language for SAIR",
  "settings.general.row.shell.title": "Terminal shell",
  "settings.general.row.shell.description": "Shell used by the terminal and agent tools",
  "settings.general.row.shell.autoDefault": "Auto (Default)",
  "settings.general.row.shell.terminalOnly": "terminal only",
  "settings.general.row.terminalPlacement.title": "Terminal placement",
  "settings.general.row.terminalPlacement.description": "Choose where the terminal opens in explorations",
  "settings.general.row.terminalPlacement.side": "Side",
  "settings.general.row.terminalPlacement.bottom": "Bottom",
  "settings.general.row.appearance.title": "Appearance",
  "settings.general.row.appearance.description": "Customise how OMM looks on your device",
  "settings.general.row.colorScheme.title": "Color scheme",
  "settings.general.row.colorScheme.description": "Choose whether OMM follows the system, light, or dark theme",
  "settings.general.row.theme.title": "Theme",
  "settings.general.row.theme.description": "Customise how OMM is themed.",
  "settings.general.row.font.title": "Code Font",
  "settings.general.row.font.description": "Customise the font used in code blocks",
  "settings.general.row.terminalFont.title": "Terminal Font",
  "settings.general.row.terminalFont.description": "Customise the font used in the terminal",
  "settings.general.row.uiFont.title": "UI Font",
  "settings.general.row.uiFont.description": "Customise the font used throughout the interface",
  "settings.general.row.showFileTree.title": "File tree",
  "settings.general.row.showFileTree.description": "Show the file tree panel in explorations",
  "settings.general.row.browserPane.title": "Browser",
  "settings.general.row.browserPane.description": "Allow agents to open and control an in-app development browser.",
  "settings.general.row.showNavigation.title": "Navigation controls",
  "settings.general.row.showNavigation.description": "Show the back and forward buttons in the desktop title bar",
  "settings.general.row.showSearch.title": "Command palette",
  "settings.general.row.showSearch.description": "Show the search and command palette button in the title bar",
  "settings.general.row.showTerminal.title": "Terminal",
  "settings.general.row.showTerminal.description": "Show the terminal button in the desktop title bar",
  "settings.general.row.renderMath.title": "Render math",
  "settings.general.row.renderMath.description": "Display LaTeX as formatted equations. Turn off to show LaTeX source.",
  "settings.general.row.showStatus.title": "Server status",
  "settings.general.row.showStatus.description": "Show the server status button in the title bar",
  "settings.general.row.showProjectIcon.title": "Show project icon",
  "settings.general.row.showProjectIcon.description": "Show project icon in exploration header",
  "settings.general.row.mobileTitlebarBottom.title": "Bottom navigation",
  "settings.general.row.mobileTitlebarBottom.description": "Place the title bar at the bottom of the screen on mobile",
  "settings.general.row.mobileDiffWrap.description":
    "Wrap long lines in mobile diffs instead of scrolling horizontally",
  "settings.general.row.showCustomAgents.title": "Show agent",
  "settings.general.row.showCustomAgents.description":
    "Switch between agents in the composer. When hidden, defaults to Build agent.",
  "settings.general.row.followUpBehavior.title": "Follow-up behavior",
  "settings.general.row.followUpBehavior.description":
    "Choose whether to queue follow-ups or steer the current turn. Use {{keybind}} to switch.",
  "settings.general.row.followUpBehavior.queue": "Queue",
  "settings.general.row.followUpBehavior.steer": "Steer",
  "settings.general.row.reasoningSummaries.title": "Show reasoning summaries",
  "settings.general.row.reasoningSummaries.description": "Display model reasoning summaries in the timeline",
  "settings.general.row.reasoningMode.title": "Model reasoning",
  "settings.general.row.reasoningMode.description": "Choose how model reasoning is displayed in the timeline",
  "settings.general.row.reasoningMode.hidden": "Hidden",
  "settings.general.row.reasoningMode.compact": "Compact",
  "settings.general.row.reasoningMode.full": "Full",
  "settings.general.row.shellToolPartsExpanded.title": "Expand shell tool parts",
  "settings.general.row.shellToolPartsExpanded.description":
    "Show shell tool parts expanded by default in the timeline",
  "settings.general.row.editToolPartsExpanded.title": "Expand edit tool parts",
  "settings.general.row.editToolPartsExpanded.description":
    "Show edit, write, and patch tool parts expanded by default in the timeline",
  "settings.general.row.pinchZoom.title": "Pinch to zoom",
  "settings.general.row.pinchZoom.description": "Allow trackpad pinch and Ctrl-scroll gestures to zoom",

  "settings.general.row.wayland.title": "Use native Wayland",
  "settings.general.row.wayland.description": "Disable X11 fallback on Wayland. Requires restart.",
  "settings.general.row.wayland.tooltip":
    "On Linux with mixed refresh-rate monitors, native Wayland can be more stable.",

  "settings.general.row.releaseNotes.title": "Release notes",
  "settings.general.row.releaseNotes.description": "Show What's New popups after updates",

  "settings.updates.row.startup.title": "Check for updates on startup",
  "settings.updates.row.startup.description": "Automatically check for updates when OMM launches",
  "settings.updates.row.check.title": "Check for updates",
  "settings.updates.row.check.description": "Manually check for updates and install if available",
  "settings.updates.test.title": "OMM TEST builds",
  "settings.updates.test.description":
    "Automatic updates are disabled. Download a new test build from GitHub Releases with an account that has access to the repository.",
  "settings.updates.test.download": "Open test downloads",
  "settings.updates.action.checkNow": "Check now",
  "settings.updates.action.checking": "Checking…",
  "settings.updates.action.downloading": "Downloading…",
  "settings.updates.action.download": "Download OMM",
  "settings.updates.migration.title": "Move from Beta to Stable",
  "settings.updates.migration.description":
    "For now, OMM Beta is moving to OMM Stable. Download version {{version}}, then install OMM from the disk image to continue receiving updates.",
  "settings.updates.action.installing": "Installing…",
  "settings.updates.toast.latest.title": "You're up to date",
  "settings.updates.toast.latest.description": "You're running the latest version of OMM.",
  "sound.option.none": "None",
  "sound.option.alert01": "Alert 01",
  "sound.option.alert02": "Alert 02",
  "sound.option.alert03": "Alert 03",
  "sound.option.alert04": "Alert 04",
  "sound.option.alert05": "Alert 05",
  "sound.option.alert06": "Alert 06",
  "sound.option.alert07": "Alert 07",
  "sound.option.alert08": "Alert 08",
  "sound.option.alert09": "Alert 09",
  "sound.option.alert10": "Alert 10",
  "sound.option.bipbop01": "Bip-bop 01",
  "sound.option.bipbop02": "Bip-bop 02",
  "sound.option.bipbop03": "Bip-bop 03",
  "sound.option.bipbop04": "Bip-bop 04",
  "sound.option.bipbop05": "Bip-bop 05",
  "sound.option.bipbop06": "Bip-bop 06",
  "sound.option.bipbop07": "Bip-bop 07",
  "sound.option.bipbop08": "Bip-bop 08",
  "sound.option.bipbop09": "Bip-bop 09",
  "sound.option.bipbop10": "Bip-bop 10",
  "sound.option.staplebops01": "Staplebops 01",
  "sound.option.staplebops02": "Staplebops 02",
  "sound.option.staplebops03": "Staplebops 03",
  "sound.option.staplebops04": "Staplebops 04",
  "sound.option.staplebops05": "Staplebops 05",
  "sound.option.staplebops06": "Staplebops 06",
  "sound.option.staplebops07": "Staplebops 07",
  "sound.option.nope01": "Nope 01",
  "sound.option.nope02": "Nope 02",
  "sound.option.nope03": "Nope 03",
  "sound.option.nope04": "Nope 04",
  "sound.option.nope05": "Nope 05",
  "sound.option.nope06": "Nope 06",
  "sound.option.nope07": "Nope 07",
  "sound.option.nope08": "Nope 08",
  "sound.option.nope09": "Nope 09",
  "sound.option.nope10": "Nope 10",
  "sound.option.nope11": "Nope 11",
  "sound.option.nope12": "Nope 12",
  "sound.option.yup01": "Yup 01",
  "sound.option.yup02": "Yup 02",
  "sound.option.yup03": "Yup 03",
  "sound.option.yup04": "Yup 04",
  "sound.option.yup05": "Yup 05",
  "sound.option.yup06": "Yup 06",

  "settings.general.notifications.agent.title": "Agent",
  "settings.general.notifications.agent.description":
    "Show system notification when the agent is complete or needs attention",
  "settings.general.notifications.permissions.title": "Permissions",
  "settings.general.notifications.permissions.description": "Show system notification when a permission is required",
  "settings.general.notifications.errors.title": "Errors",
  "settings.general.notifications.errors.description": "Show system notification when an error occurs",

  "settings.general.sounds.agent.title": "Agent",
  "settings.general.sounds.agent.description": "Play sound when the agent is complete or needs attention",
  "settings.general.sounds.permissions.title": "Permissions",
  "settings.general.sounds.permissions.description": "Play sound when a permission is required",
  "settings.general.sounds.errors.title": "Errors",
  "settings.general.sounds.errors.description": "Play sound when an error occurs",

  "settings.shortcuts.title": "Keyboard shortcuts",
  "settings.shortcuts.reset.button": "Reset to defaults",
  "settings.shortcuts.reset.toast.title": "Shortcuts reset",
  "settings.shortcuts.reset.toast.description": "Keyboard shortcuts have been reset to defaults.",
  "settings.shortcuts.conflict.title": "Shortcut already in use",
  "settings.shortcuts.conflict.description": "{{keybind}} is already assigned to {{titles}}.",
  "settings.shortcuts.unassigned": "Unassigned",
  "settings.shortcuts.pressKeys": "Press keys",
  "settings.shortcuts.search.placeholder": "Search shortcuts",
  "settings.shortcuts.search.empty": "No shortcuts found",

  "settings.shortcuts.group.general": "General",
  "settings.shortcuts.group.session": "Exploration",
  "settings.shortcuts.group.navigation": "Navigation",
  "settings.shortcuts.group.modelAndAgent": "Model and agent",
  "settings.shortcuts.group.terminal": "Terminal",
  "settings.shortcuts.group.prompt": "Prompt",

  "settings.providers.title": "Providers",
  "settings.providers.description": "Connect and manage model providers",
  "settings.providers.section.connected": "Connected providers",
  "settings.providers.connected.empty": "No connected providers",
  "settings.providers.connected.environmentDescription": "Connected from your environment variables",
  "settings.providers.section.popular": "Popular providers",
  "settings.providers.custom.description": "Add an OpenAI-compatible provider by base URL.",
  "settings.providers.tag.environment": "Environment",
  "settings.providers.tag.config": "Config",
  "settings.providers.tag.custom": "Custom",
  "settings.providers.tag.other": "Other",
  "settings.models.title": "Models",
  "settings.models.description": "Choose which models appear in model picker",
  "settings.agents.title": "Agents",
  "settings.agents.description": "Agent settings will be configurable here.",
  "settings.commands.title": "Commands",
  "settings.commands.description": "Command settings will be configurable here.",
  "settings.mcp.title": "MCP",
  "settings.mcp.description": "MCP settings will be configurable here.",

  "settings.permissions.title": "Permissions",
  "settings.permissions.description": "Control what tools the server can use by default.",
  "settings.permissions.section.tools": "Tools",
  "settings.permissions.toast.updateFailed.title": "Failed to update permissions",

  "settings.permissions.action.allow": "Allow",
  "settings.permissions.action.ask": "Ask",
  "settings.permissions.action.deny": "Deny",

  "settings.permissions.tool.read.title": "Read",
  "settings.permissions.tool.read.description": "Reading a file (matches the file path)",
  "settings.permissions.tool.edit.title": "Edit",
  "settings.permissions.tool.edit.description": "Modify files, including edits, writes, and patches",
  "settings.permissions.tool.glob.title": "Glob",
  "settings.permissions.tool.glob.description": "Match files using glob patterns",
  "settings.permissions.tool.grep.title": "Grep",
  "settings.permissions.tool.grep.description": "Search file contents using regular expressions",
  "settings.permissions.tool.list.title": "List",
  "settings.permissions.tool.list.description": "List files within a directory",
  "settings.permissions.tool.bash.title": "Bash",
  "settings.permissions.tool.bash.description": "Run shell commands",
  "settings.permissions.tool.task.title": "Task",
  "settings.permissions.tool.task.description": "Launch sub-agents",
  "settings.permissions.tool.skill.title": "Skill",
  "settings.permissions.tool.skill.description": "Load a skill by name",
  "settings.permissions.tool.lsp.title": "LSP",
  "settings.permissions.tool.lsp.description": "Run language server queries",
  "settings.permissions.tool.todowrite.title": "Todo Write",
  "settings.permissions.tool.todowrite.description": "Update the todo list",
  "settings.permissions.tool.webfetch.title": "Web Fetch",
  "settings.permissions.tool.webfetch.description": "Fetch content from a URL",
  "settings.permissions.tool.websearch.title": "Web Search",
  "settings.permissions.tool.websearch.description": "Search the web",
  "settings.permissions.tool.external_directory.title": "External Directory",
  "settings.permissions.tool.external_directory.description": "Access files outside the project directory",
  "settings.permissions.tool.doom_loop.title": "Doom Loop",
  "settings.permissions.tool.doom_loop.description": "Detect repeated tool calls with identical input",

  "session.delete.failed.title": "Failed to delete exploration",
  "session.delete.title": "Delete exploration",
  "session.delete.confirm": 'Delete exploration "{{name}}"?',
  "session.delete.button": "Delete exploration",

  "workspace.new": "New worktree",
  "common.viewAll": "View all",
  "session.new.workspace.local.tooltip": "Uses project’s current checkout",
  "session.new.workspace.new.tooltip": "Creates isolated copy from current checkout",
  "session.new.workspace.fromBranch": "from {{branch}}",
  "session.new.workspace.createFrom": "Create from branch",
  "session.new.workspace.branch.search.placeholder": "Search branches",
  "session.new.workspace.trigger.tooltip": "Select where to run exploration",
  "session.new.workspace.search.placeholder": "Search worktrees",
  "session.new.workspace.search.empty": "No matching worktrees",
  "settings.tab.workspaces": "Worktrees",
  "settings.workspaces.description": "Review worktrees and manage disk usage",
  "settings.workspaces.filter.all": "All projects",
  "settings.workspaces.empty": "No worktrees yet",
  "settings.workspaces.empty.description": "Worktrees created in OMM will appear here",
  "settings.workspaces.count.one": "{{count}} worktree",
  "settings.workspaces.count.other": "{{count}} worktrees",
  "settings.workspaces.sessions.one": "{{count}} exploration in {{project}}",
  "settings.workspaces.sessions.other": "{{count}} explorations in {{project}}",
  "settings.workspaces.sessions.filtered.one": "{{count}} exploration",
  "settings.workspaces.sessions.filtered.other": "{{count}} explorations",
  "settings.workspaces.lastActiveSession": "Last active exploration",
  "settings.workspaces.deleteAll": "Delete all worktrees",
  "settings.workspaces.deleteAll.confirm.one": "This will permanently delete {{count}} selected worktree.",
  "settings.workspaces.deleteAll.confirm.other": "This will permanently delete {{count}} selected worktrees.",
  "settings.workspaces.deleteWithoutSessions": "Delete worktrees without explorations",
  "settings.workspaces.deleteWithoutSessions.confirm.one":
    "This will permanently delete {{count}} worktree without linked explorations.",
  "settings.workspaces.deleteWithoutSessions.confirm.other":
    "This will permanently delete {{count}} worktrees without linked explorations.",
  "settings.workspaces.deleteWithoutSessions.warning":
    "Worktrees with unmerged changes or active locations will be kept.",
  "settings.workspaces.delete.button": "Delete worktrees",
  "settings.workspaces.delete.warning": "This permanently deletes the worktree and its branch.",
  "settings.workspaces.deleteAll.warning":
    "Worktrees with unmerged changes, linked explorations, or active locations will be kept.",
  "settings.workspaces.delete.blocked.active": "The active worktree cannot be deleted.",
  "settings.workspaces.delete.blocked.linked":
    "Linked explorations will remain, but their working directory will no longer exist.",
  "settings.workspaces.default.title": "Default environment",
  "settings.workspaces.default.description": "Choose where new explorations start",
  "settings.workspaces.default.lastUsed": "Last used per project",
  "settings.workspaces.default.local": "Local directory",
  "settings.workspaces.default.new": "New worktree",
  "workspace.move.title": "Move to worktree",
  "workspace.move.menu.title": "Move exploration to",
  "workspace.move.failed": "Failed to move exploration",
  "workspace.lifecycle.creating": "Creating worktree",
  "workspace.lifecycle.created": "Worktree created",
  "workspace.lifecycle.deleting": "Deleting…",
  "workspace.lifecycle.starting": "Starting exploration",
  "workspace.onboarding.title": "Isolate explorations with worktrees",
  "workspace.onboarding.description": "Each gets its own checkout",
  "workspace.lifecycle.moving": "Moving to worktree",
  "workspace.lifecycle.set": "Worktree set",
  "session.summary.title": "Summary",
  "session.summary.tooltip": "Summary",
  "session.summary.noBranch": "No branch",
  "session.summary.basedOn": "Based on {{branch}}",
  "session.summary.server": "Extensions",
  "session.summary.chooseProject": "Choose a project",
  "session.summary.mcp.onCreation": "Applies when the worktree is created",
  "session.summary.mcp.prepareFailed": "Could not prepare MCP servers",
  "session.summary.mcp.unavailable": "MCP server {{name}} is not available in this worktree.",
  "session.summary.mcp.signInBeforeSend": "Sign in to {{name}} before sending the prompt.",
  "session.summary.mcp.notReady": "MCP server {{name}} is not ready. Resolve its connection before sending the prompt.",
  "session.summary.mcp": "MCP",
  "session.summary.mcp.title": "Configured MCP servers",
  "session.summary.plugins": "Plugins",
  "session.summary.plugins.configured": "Configured plugins",
  "session.summary.skills": "Skills",
  "session.summary.skills.configured": "Configured skills",
  "session.summary.lsp": "LSP",
  "session.summary.failed": "Failed",
  "session.summary.retry": "Retry",
  "session.summary.connecting": "Connecting…",
  "session.summary.needsAuth": "Sign in required",
  "session.summary.configure": "Configuration file",
  "session.summary.copyConfigPath": "Copy configuration file path",
  "session.summary.configFileMissing": "No configuration file found",
  "session.summary.mcp.empty": "No MCP servers configured",
  "session.summary.mcp.add": "Add servers in opencode.json",
  "session.summary.plugins.manage": "Manage plugins in opencode.json",
  "session.summary.plugins.empty": "No plugins configured",
  "session.summary.plugins.add": "Add plugins in opencode.json",
  "session.summary.skills.manage": "Manage skills in opencode.json",
  "session.summary.skills.empty": "No skills configured",
  "session.summary.skills.add": "Add skills in opencode.json",
  "session.summary.lsp.configured": "Configured LSPs",
  "session.summary.lsp.empty": "No LSP servers configured",
  "session.summary.lsp.manage": "Manage LSP in opencode.json",
  "workspace.type.local": "local",
  "workspace.type.sandbox": "sandbox",
  "workspace.create.failed.title": "Failed to create worktree",
  "workspace.delete.failed.title": "Failed to delete worktree",
  "workspace.resetting.title": "Resetting worktree",
  "workspace.resetting.description": "This may take a minute.",
  "workspace.reset.failed.title": "Failed to reset worktree",
  "workspace.reset.success.title": "Worktree reset",
  "workspace.reset.success.description": "Worktree now matches the default branch.",
  "workspace.error.stillPreparing": "Worktree is still preparing",
  "workspace.status.checking": "Checking for unmerged changes…",
  "workspace.status.error": "Unable to verify git status.",
  "workspace.status.clean": "No unmerged changes detected.",
  "workspace.status.dirty": "Unmerged changes will be lost.",
  "workspace.delete.title": "Delete worktree",
  "workspace.delete.confirm": "Delete “{{name}}”?",
  "workspace.delete.location": "Location",
  "workspace.delete.button": "Delete worktree",
  "workspace.reset.title": "Reset worktree",
  "workspace.reset.confirm": 'Reset worktree "{{name}}"?',
  "workspace.reset.button": "Reset worktree",
  "workspace.reset.archived.none": "No active explorations will be archived.",
  "workspace.reset.archived.one": "1 exploration will be archived.",
  "workspace.reset.archived.many": "{{count}} explorations will be archived.",
  "workspace.reset.note": "This will reset the worktree to match the default branch.",
}

export default dict
